// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsernameRouteImport } from './routes/$username'
import { Route as R404RouteImport } from './routes/404'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as UserRouteImport } from './routes/_user'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as UsernameProfileRouteImport } from './routes/$username/_profile'
import { Route as UsernameOfferRouteImport } from './routes/$username/offer'
import { Route as Public6FigureReadinessScoreRouteImport } from './routes/_public/6-figure-readiness-score'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as PublicArticlesRouteImport } from './routes/_public/articles'
import { Route as PublicBrandRouteImport } from './routes/_public/brand'
import { Route as PublicCoachBusinessBuilderRouteImport } from './routes/_public/coach-business-builder'
import { Route as PublicCoachingBusinessRouteImport } from './routes/_public/coaching-business'
import { Route as PublicCoachingIntelligenceRouteImport } from './routes/_public/coaching-intelligence'
import { Route as PublicDcmVsBetterupRouteImport } from './routes/_public/dcm-vs-betterup'
import { Route as PublicHowItWorksRouteImport } from './routes/_public/how-it-works'
import { Route as PublicOrganizationsRouteImport } from './routes/_public/organizations'
import { Route as PublicOurCoachesRouteImport } from './routes/_public/our-coaches'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicPrivacyPolicyRouteImport } from './routes/_public/privacy-policy'
import { Route as PublicTrainingProgramsRouteImport } from './routes/_public/training-programs'
import { Route as PublicVisionRouteImport } from './routes/_public/vision'
import { Route as PublicWhatWeOfferRouteImport } from './routes/_public/what-we-offer'
import { Route as PublicWheelRouteImport } from './routes/_public/wheel'
import { Route as PublicWheelOfLifeRouteImport } from './routes/_public/wheel-of-life'
import { Route as UserBecomeACoachRouteImport } from './routes/_user/become-a-coach'
import { Route as UserCoachingRouteImport } from './routes/_user/coaching'
import { Route as UserContactsRouteImport } from './routes/_user/contacts'
import { Route as UserHelpRouteImport } from './routes/_user/help'
import { Route as UserLifeDesignRouteImport } from './routes/_user/life-design'
import { Route as UserMessagesRouteImport } from './routes/_user/messages'
import { Route as UserMyCoachingRouteImport } from './routes/_user/my-coaching'
import { Route as UserMyOrganizationRouteImport } from './routes/_user/my-organization'
import { Route as UserProPlusRouteImport } from './routes/_user/pro-plus'
import { Route as UserReferralsRouteImport } from './routes/_user/referrals'
import { Route as UserSettingsRouteImport } from './routes/_user/settings'
import { Route as UserSummitsRouteImport } from './routes/_user/summits'
import { Route as UserWelcomeRouteImport } from './routes/_user/welcome'
import { Route as AcceptInvitationIndexRouteImport } from './routes/accept-invitation/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminCihRouteImport } from './routes/admin/cih'
import { Route as AdminCoursesRouteImport } from './routes/admin/courses'
import { Route as AdminTransformationStoriesRouteImport } from './routes/admin/transformation-stories'
import { Route as AdminVideosRouteImport } from './routes/admin/videos'
import { Route as CoachSplatRouteImport } from './routes/coach/$'
import { Route as IntakeIndexRouteImport } from './routes/intake/index'
import { Route as SummitSpecialThankYouRouteImport } from './routes/summit-special/thank-you'
import { Route as SummitIndexRouteImport } from './routes/summit/index'
import { Route as SummitAgendaRouteImport } from './routes/summit/agenda'
import { Route as SummitRegisterRouteImport } from './routes/summit/register'
import { Route as SummitStreamRouteImport } from './routes/summit/stream'
import { Route as UsernameProfileIndexRouteImport } from './routes/$username/_profile/index'
import { Route as UsernameProfileResourcesRouteImport } from './routes/$username/_profile/resources'
import { Route as UsernameBookIndexRouteImport } from './routes/$username/book/index'
import { Route as UsernameContactIndexRouteImport } from './routes/$username/contact/index'
import { Route as UsernameOfferIndexRouteImport } from './routes/$username/offer/index'
import { Route as UsernameWheelOfLifeIndexRouteImport } from './routes/$username/wheel-of-life/index'
import { Route as AuthAcceptTokenIndexRouteImport } from './routes/_auth/accept-token/index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/_auth/forgot-password/index'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index'
import { Route as AuthSigninIndexRouteImport } from './routes/_auth/signin/index'
import { Route as AuthSignupIndexRouteImport } from './routes/_auth/signup/index'
import { Route as PublicAboutIndexRouteImport } from './routes/_public/about/index'
import { Route as PublicAboutAdvisoryCouncilRouteImport } from './routes/_public/about/advisory-council'
import { Route as PublicArticlesIndexRouteImport } from './routes/_public/articles/index'
import { Route as PublicArticlesSlugRouteImport } from './routes/_public/articles/$slug'
import { Route as PublicCcosIndexRouteImport } from './routes/_public/ccos/index'
import { Route as PublicCoachesIndexRouteImport } from './routes/_public/coaches/index'
import { Route as PublicCoachingBusinessIndexRouteImport } from './routes/_public/coaching-business/index'
import { Route as PublicCoachingBusinessGuideSlugRouteImport } from './routes/_public/coaching-business/$guideSlug'
import { Route as PublicCoachingBusinessPlaybooksRouteImport } from './routes/_public/coaching-business/playbooks'
import { Route as PublicCoachingForIndexRouteImport } from './routes/_public/coaching-for/index'
import { Route as PublicCoachingForChallengeSlugRouteImport } from './routes/_public/coaching-for/$challengeSlug'
import { Route as PublicDiscoveryIndexRouteImport } from './routes/_public/discovery/index'
import { Route as PublicDiscoveryUsernameRouteImport } from './routes/_public/discovery/$username'
import { Route as PublicDiscoveryMatchRouteImport } from './routes/_public/discovery/match'
import { Route as PublicDiscoveryRefineRouteImport } from './routes/_public/discovery/refine'
import { Route as PublicDiscoveryResultsRouteImport } from './routes/_public/discovery/results'
import { Route as PublicDiscoveryStepsRouteImport } from './routes/_public/discovery/steps'
import { Route as PublicFrameworksIndexRouteImport } from './routes/_public/frameworks/index'
import { Route as PublicFrameworksSlugRouteImport } from './routes/_public/frameworks/$slug'
import { Route as PublicGoalsShareSlugRouteImport } from './routes/_public/goals/$shareSlug'
import { Route as PublicOrganizationInviteTokenRouteImport } from './routes/_public/organization-invite/$token'
import { Route as PublicOrganizationsIndexRouteImport } from './routes/_public/organizations/index'
import { Route as PublicOrganizationsSlugRouteImport } from './routes/_public/organizations/$slug'
import { Route as PublicStoriesIndexRouteImport } from './routes/_public/stories/index'
import { Route as PublicSummitDebugRouteImport } from './routes/_public/summit/debug'
import { Route as PublicTrainingProgramsIndexRouteImport } from './routes/_public/training-programs/index'
import { Route as PublicTrainingProgramsSlugRouteImport } from './routes/_public/training-programs/$slug'
import { Route as PublicWIdRouteImport } from './routes/_public/w.$id'
import { Route as PublicWheelOfLifeIndexRouteImport } from './routes/_public/wheel-of-life/index'
import { Route as PublicWheelOfLifeTemplateRouteImport } from './routes/_public/wheel-of-life/template'
import { Route as UserCoachDiscoveryIndexRouteImport } from './routes/_user/coach-discovery/index'
import { Route as UserCoachFinderIndexRouteImport } from './routes/_user/coach-finder/index'
import { Route as UserCoachingIndexRouteImport } from './routes/_user/coaching/index'
import { Route as UserCoachingEngagementIdRouteImport } from './routes/_user/coaching/$engagementId'
import { Route as UserContactsIndexRouteImport } from './routes/_user/contacts/index'
import { Route as UserDashboardIndexRouteImport } from './routes/_user/dashboard/index'
import { Route as UserLifeDesignIndexRouteImport } from './routes/_user/life-design/index'
import { Route as UserLifeDesignCategoryIdRouteImport } from './routes/_user/life-design/$categoryId'
import { Route as UserLifeDesignGoalsRouteImport } from './routes/_user/life-design/goals'
import { Route as UserLifeDesignNewCategoryRouteImport } from './routes/_user/life-design/new-category'
import { Route as UserLifeDesignOverallVisionRouteImport } from './routes/_user/life-design/overall-vision'
import { Route as UserMessagesIndexRouteImport } from './routes/_user/messages/index'
import { Route as UserMyCoachingIndexRouteImport } from './routes/_user/my-coaching/index'
import { Route as UserMyCoachingAcceleratorRouteImport } from './routes/_user/my-coaching/accelerator'
import { Route as UserMyCoachingArticlesRouteImport } from './routes/_user/my-coaching/articles'
import { Route as UserMyCoachingProfileRouteImport } from './routes/_user/my-coaching/profile'
import { Route as UserMyCoachingReferralsRouteImport } from './routes/_user/my-coaching/referrals'
import { Route as UserMyCoachingStripeConnectRouteImport } from './routes/_user/my-coaching/stripe-connect'
import { Route as UserMyCoachingWelcomeRouteImport } from './routes/_user/my-coaching/welcome'
import { Route as UserMyCoachingWhatsComingRouteImport } from './routes/_user/my-coaching/whats-coming'
import { Route as UserMyCoachingWhatsNewRouteImport } from './routes/_user/my-coaching/whats-new'
import { Route as UserMyOrganizationIndexRouteImport } from './routes/_user/my-organization/index'
import { Route as UserMyOrganizationSlugRouteImport } from './routes/_user/my-organization/$slug'
import { Route as UserSettingsIndexRouteImport } from './routes/_user/settings/index'
import { Route as UserSettingsProfileRouteImport } from './routes/_user/settings/profile'
import { Route as UserSummitsIndexRouteImport } from './routes/_user/summits/index'
import { Route as AdminCallsAndLinksIndexRouteImport } from './routes/admin/calls-and-links/index'
import { Route as AdminCihIndexRouteImport } from './routes/admin/cih/index'
import { Route as AdminCihPageChangesRouteImport } from './routes/admin/cih/page-changes'
import { Route as AdminCihStoriesRouteImport } from './routes/admin/cih/stories'
import { Route as AdminCoachesIndexRouteImport } from './routes/admin/coaches/index'
import { Route as AdminCoursesIndexRouteImport } from './routes/admin/courses/index'
import { Route as AdminCoursesCourseIdRouteImport } from './routes/admin/courses/$courseId'
import { Route as AdminCtpsIndexRouteImport } from './routes/admin/ctps/index'
import { Route as AdminFeatureFlagsIndexRouteImport } from './routes/admin/feature-flags/index'
import { Route as AdminFeatureVotesIndexRouteImport } from './routes/admin/feature-votes/index'
import { Route as AdminFeeExemptionsIndexRouteImport } from './routes/admin/fee-exemptions/index'
import { Route as AdminFunnelHealthIndexRouteImport } from './routes/admin/funnel-health/index'
import { Route as AdminIntegrationsIndexRouteImport } from './routes/admin/integrations/index'
import { Route as AdminMpaiIndexRouteImport } from './routes/admin/mpai/index'
import { Route as AdminNovaUsageIndexRouteImport } from './routes/admin/nova-usage/index'
import { Route as AdminReferralRewardsIndexRouteImport } from './routes/admin/referral-rewards/index'
import { Route as AdminSummitCtaIndexRouteImport } from './routes/admin/summit-cta/index'
import { Route as AdminSummitSessionsIndexRouteImport } from './routes/admin/summit-sessions/index'
import { Route as AdminSummitSessionsSessionIdRouteImport } from './routes/admin/summit-sessions/$sessionId'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminVerificationsIndexRouteImport } from './routes/admin/verifications/index'
import { Route as AdminVideosIndexRouteImport } from './routes/admin/videos/index'
import { Route as AdminVideosPlacementsRouteImport } from './routes/admin/videos/placements'
import { Route as AdminWhatsNewIndexRouteImport } from './routes/admin/whats-new/index'
import { Route as ApiGhlSetUserPermissionsIndexRouteImport } from './routes/api/ghl-set-user-permissions/index'
import { Route as EmbedAppointmentsChartIndexRouteImport } from './routes/embed/appointments-chart/index'
import { Route as EmbedCoachDashboardIndexRouteImport } from './routes/embed/coach-dashboard/index'
import { Route as EmbedCoachLevelsIndexRouteImport } from './routes/embed/coach-levels/index'
import { Route as EmbedCoachesChartIndexRouteImport } from './routes/embed/coaches-chart/index'
import { Route as EmbedDiscoveryChartIndexRouteImport } from './routes/embed/discovery-chart/index'
import { Route as EmbedDiscoveryEligibleCoachesIndexRouteImport } from './routes/embed/discovery-eligible-coaches/index'
import { Route as EmbedEngagementsChartIndexRouteImport } from './routes/embed/engagements-chart/index'
import { Route as EmbedIntakeChartIndexRouteImport } from './routes/embed/intake-chart/index'
import { Route as EmbedNewCoaches30dIndexRouteImport } from './routes/embed/new-coaches-30d/index'
import { Route as EmbedNumberOfAppointmentsIndexRouteImport } from './routes/embed/number-of-appointments/index'
import { Route as EmbedNumberOfCoachesIndexRouteImport } from './routes/embed/number-of-coaches/index'
import { Route as EmbedNumberOfUsersIndexRouteImport } from './routes/embed/number-of-users/index'
import { Route as EmbedSessionsChartIndexRouteImport } from './routes/embed/sessions-chart/index'
import { Route as EmbedUsersChartIndexRouteImport } from './routes/embed/users-chart/index'
import { Route as SummitSpecialCheckoutOfferIdRouteImport } from './routes/summit-special/checkout/$offerId'
import { Route as SummitSummitIdAgendaRouteImport } from './routes/summit/$summitId/agenda'
import { Route as SummitDayNumberRouteImport } from './routes/summit/day/$number'
import { Route as UsernameProfileResourcesIndexRouteImport } from './routes/$username/_profile/resources/index'
import { Route as UsernameOfferOfferIdIndexRouteImport } from './routes/$username/offer/$offerId/index'
import { Route as UsernameWheelOfLifeResultsIdRouteImport } from './routes/$username/wheel-of-life/results.$id'
import { Route as PublicBrandComponentsIndexRouteImport } from './routes/_public/brand/components/index'
import { Route as PublicBrandGuidelineIndexRouteImport } from './routes/_public/brand/guideline/index'
import { Route as PublicCoachesCategoryIndexRouteImport } from './routes/_public/coaches/category/index'
import { Route as PublicCoachesCcoIndexRouteImport } from './routes/_public/coaches/cco/index'
import { Route as PublicCoachesCityIndexRouteImport } from './routes/_public/coaches/city/index'
import { Route as PublicCoachesCtpIndexRouteImport } from './routes/_public/coaches/ctp/index'
import { Route as PublicCoachesCtpSlugRouteImport } from './routes/_public/coaches/ctp/$slug'
import { Route as PublicCoachesFoundingIndexRouteImport } from './routes/_public/coaches/founding/index'
import { Route as PublicCoachesSubcategoryIndexRouteImport } from './routes/_public/coaches/subcategory/index'
import { Route as PublicCoachingBusinessPlaybooksIndexRouteImport } from './routes/_public/coaching-business/playbooks/index'
import { Route as PublicCoachingBusinessPlaybooksSlugRouteImport } from './routes/_public/coaching-business/playbooks/$slug'
import { Route as PublicCoachingForChallengeSlugIndexRouteImport } from './routes/_public/coaching-for/$challengeSlug/index'
import { Route as PublicCoachingForChallengeSlugArticlesRouteImport } from './routes/_public/coaching-for/$challengeSlug/articles'
import { Route as PublicCoachingForChallengeSlugCoachesRouteImport } from './routes/_public/coaching-for/$challengeSlug/coaches'
import { Route as PublicDiscoveryUsernameIndexRouteImport } from './routes/_public/discovery/$username/index'
import { Route as PublicDiscoveryMatchIndexRouteImport } from './routes/_public/discovery/match/index'
import { Route as PublicDiscoveryMatchContextRouteImport } from './routes/_public/discovery/match/context'
import { Route as PublicDiscoveryRefineIndexRouteImport } from './routes/_public/discovery/refine/index'
import { Route as PublicDiscoveryRefineFitRouteImport } from './routes/_public/discovery/refine/fit'
import { Route as PublicDiscoveryRefineLogisticsRouteImport } from './routes/_public/discovery/refine/logistics'
import { Route as PublicDiscoveryStepsIndexRouteImport } from './routes/_public/discovery/steps/index'
import { Route as PublicFrameworksSlugIndexRouteImport } from './routes/_public/frameworks/$slug/index'
import { Route as PublicFrameworksSlugCoachesRouteImport } from './routes/_public/frameworks/$slug/coaches'
import { Route as PublicFrameworksSlugTrainingProgramsRouteImport } from './routes/_public/frameworks/$slug/training-programs'
import { Route as PublicOrganizationsSlugIndexRouteImport } from './routes/_public/organizations/$slug/index'
import { Route as PublicOrganizationsSlugClaimRouteImport } from './routes/_public/organizations/$slug/claim'
import { Route as PublicOrganizationsSlugCoachesRouteImport } from './routes/_public/organizations/$slug/coaches'
import { Route as PublicOrganizationsSlugJoinRouteImport } from './routes/_public/organizations/$slug/join'
import { Route as PublicOrganizationsSlugTrainingProgramsRouteImport } from './routes/_public/organizations/$slug/training-programs'
import { Route as PublicPageNameIndexRouteImport } from './routes/_public/page/$name/index'
import { Route as PublicSummitSummitIdRecapRouteImport } from './routes/_public/summit/$summitId/recap'
import { Route as PublicTrainingProgramsSlugIndexRouteImport } from './routes/_public/training-programs/$slug/index'
import { Route as PublicTrainingProgramsSlugCoachesRouteImport } from './routes/_public/training-programs/$slug/coaches'
import { Route as PublicWheelOfLifeResultsIdRouteImport } from './routes/_public/wheel-of-life/results.$id'
import { Route as UserCoachingEngagementIdIndexRouteImport } from './routes/_user/coaching/$engagementId/index'
import { Route as UserCoachingEngagementIdAdminRouteImport } from './routes/_user/coaching/$engagementId/admin'
import { Route as UserCoachingEngagementIdCoachingGoalsAndOutcomesRouteImport } from './routes/_user/coaching/$engagementId/coaching-goals-and-outcomes'
import { Route as UserCoachingEngagementIdCoachingResourcesRouteImport } from './routes/_user/coaching/$engagementId/coaching-resources'
import { Route as UserCoachingEngagementIdHomeworkRouteImport } from './routes/_user/coaching/$engagementId/homework'
import { Route as UserCoachingEngagementIdMessagesRouteImport } from './routes/_user/coaching/$engagementId/messages'
import { Route as UserCoachingEngagementIdNotesRouteImport } from './routes/_user/coaching/$engagementId/notes'
import { Route as UserCoachingEngagementIdSessionsRouteImport } from './routes/_user/coaching/$engagementId/sessions'
import { Route as UserCoachingEngagementIdWelcomeRouteImport } from './routes/_user/coaching/$engagementId_.welcome'
import { Route as UserMessagesConversationIdIndexRouteImport } from './routes/_user/messages/$conversationId/index'
import { Route as UserMyCoachingArticlesIndexRouteImport } from './routes/_user/my-coaching/articles/index'
import { Route as UserMyCoachingArticlesArticleIdRouteImport } from './routes/_user/my-coaching/articles/$articleId'
import { Route as UserMyCoachingArticlesNewRouteImport } from './routes/_user/my-coaching/articles/new'
import { Route as UserMyCoachingBusinessLeadMagnetsRouteImport } from './routes/_user/my-coaching/business/lead-magnets'
import { Route as UserMyCoachingBusinessMarketingSuiteRouteImport } from './routes/_user/my-coaching/business/marketing-suite'
import { Route as UserMyCoachingBusinessNovaRouteImport } from './routes/_user/my-coaching/business/nova'
import { Route as UserMyCoachingBusinessReadinessScoreRouteImport } from './routes/_user/my-coaching/business/readiness-score'
import { Route as UserMyCoachingBusinessReadingRouteImport } from './routes/_user/my-coaching/business/reading'
import { Route as UserMyCoachingClientsDashboardRouteImport } from './routes/_user/my-coaching/clients/dashboard'
import { Route as UserMyCoachingClientsInvoicesRouteImport } from './routes/_user/my-coaching/clients/invoices'
import { Route as UserMyCoachingClientsProgramsRouteImport } from './routes/_user/my-coaching/clients/programs'
import { Route as UserMyCoachingProfileBioRouteImport } from './routes/_user/my-coaching/profile/bio'
import { Route as UserMyCoachingProfileDetailsRouteImport } from './routes/_user/my-coaching/profile/details'
import { Route as UserMyCoachingProfileOffersRouteImport } from './routes/_user/my-coaching/profile/offers'
import { Route as UserMyCoachingProfilePersonalInfoRouteImport } from './routes/_user/my-coaching/profile/personal-info'
import { Route as UserMyCoachingProfileQualificationsRouteImport } from './routes/_user/my-coaching/profile/qualifications'
import { Route as UserMyCoachingProfileTestimonialsRouteImport } from './routes/_user/my-coaching/profile/testimonials'
import { Route as UserMyOrganizationSlugIndexRouteImport } from './routes/_user/my-organization/$slug/index'
import { Route as UserMyOrganizationSlugClaimsRouteImport } from './routes/_user/my-organization/$slug/claims'
import { Route as UserMyOrganizationSlugGraduatesRouteImport } from './routes/_user/my-organization/$slug/graduates'
import { Route as UserMyOrganizationSlugInviteRouteImport } from './routes/_user/my-organization/$slug/invite'
import { Route as UserMyOrganizationSlugPagesRouteImport } from './routes/_user/my-organization/$slug/pages'
import { Route as UserSettingsAccountIndexRouteImport } from './routes/_user/settings/account/index'
import { Route as UserSettingsCalendarIndexRouteImport } from './routes/_user/settings/calendar/index'
import { Route as UserSettingsPasswordIndexRouteImport } from './routes/_user/settings/password/index'
import { Route as UserSettingsProfileIndexRouteImport } from './routes/_user/settings/profile/index'
import { Route as UserSettingsProfileBillingRouteImport } from './routes/_user/settings/profile/billing'
import { Route as UserSettingsProfileCoachingPreferencesRouteImport } from './routes/_user/settings/profile/coaching-preferences'
import { Route as UserSettingsProfilePasswordSettingsRouteImport } from './routes/_user/settings/profile/password-settings'
import { Route as AdminCihArticlesIndexRouteImport } from './routes/admin/cih/articles/index'
import { Route as AdminCihArticlesArticleIdRouteImport } from './routes/admin/cih/articles/$articleId'
import { Route as AdminCihArticlesNewRouteImport } from './routes/admin/cih/articles/new'
import { Route as AdminCihCcosIndexRouteImport } from './routes/admin/cih/ccos/index'
import { Route as AdminCihCcosCcoIdRouteImport } from './routes/admin/cih/ccos/$ccoId'
import { Route as AdminCihChallengesIndexRouteImport } from './routes/admin/cih/challenges/index'
import { Route as AdminCihChallengesChallengeIdRouteImport } from './routes/admin/cih/challenges/$challengeId'
import { Route as AdminCihCtpsIndexRouteImport } from './routes/admin/cih/ctps/index'
import { Route as AdminCihCtpsCtpIdRouteImport } from './routes/admin/cih/ctps/$ctpId'
import { Route as AdminCihFrameworksIndexRouteImport } from './routes/admin/cih/frameworks/index'
import { Route as AdminCihFrameworksFrameworkIdRouteImport } from './routes/admin/cih/frameworks/$frameworkId'
import { Route as AdminCihGuidesIndexRouteImport } from './routes/admin/cih/guides/index'
import { Route as AdminCihGuidesGuideIdRouteImport } from './routes/admin/cih/guides/$guideId'
import { Route as AdminCihPlaybooksIndexRouteImport } from './routes/admin/cih/playbooks/index'
import { Route as AdminCihPlaybooksPlaybookIdRouteImport } from './routes/admin/cih/playbooks/$playbookId'
import { Route as AdminCihStoriesIndexRouteImport } from './routes/admin/cih/stories/index'
import { Route as AdminCihStoriesStoryIdRouteImport } from './routes/admin/cih/stories/$storyId'
import { Route as AdminCihThoughtLeadersIndexRouteImport } from './routes/admin/cih/thought-leaders/index'
import { Route as AdminCihThoughtLeadersThoughtLeaderIdRouteImport } from './routes/admin/cih/thought-leaders/$thoughtLeaderId'
import { Route as AdminCoursesCourseIdIndexRouteImport } from './routes/admin/courses/$courseId/index'
import { Route as UsernameProfileResourcesResourceIdIndexRouteImport } from './routes/$username/_profile/resources/$resourceId/index'
import { Route as UsernameWheelOfLifeResultsIdPrintRouteImport } from './routes/$username/wheel-of-life/results.$id_.print'
import { Route as PublicCoachesCategoryCategorySlugIndexRouteImport } from './routes/_public/coaches/category/$categorySlug/index'
import { Route as PublicCoachesCcoSlugIndexRouteImport } from './routes/_public/coaches/cco/$slug/index'
import { Route as PublicCoachesCitySlugIndexRouteImport } from './routes/_public/coaches/city/$slug/index'
import { Route as PublicCoachesSubcategorySubcategorySlugIndexRouteImport } from './routes/_public/coaches/subcategory/$subcategorySlug/index'
import { Route as PublicDiscoveryUsernameBookIndexRouteImport } from './routes/_public/discovery/$username/book/index'
import { Route as PublicDiscoveryUsernameOfferIndexRouteImport } from './routes/_public/discovery/$username/offer/index'
import { Route as PublicDiscoveryUsernameResourcesIndexRouteImport } from './routes/_public/discovery/$username/resources/index'
import { Route as PublicDiscoverySteps1IndexRouteImport } from './routes/_public/discovery/steps/1/index'
import { Route as PublicDiscoverySteps10IndexRouteImport } from './routes/_public/discovery/steps/10/index'
import { Route as PublicDiscoverySteps2IndexRouteImport } from './routes/_public/discovery/steps/2/index'
import { Route as PublicDiscoverySteps3IndexRouteImport } from './routes/_public/discovery/steps/3/index'
import { Route as PublicDiscoverySteps4IndexRouteImport } from './routes/_public/discovery/steps/4/index'
import { Route as PublicDiscoverySteps5IndexRouteImport } from './routes/_public/discovery/steps/5/index'
import { Route as PublicDiscoverySteps6IndexRouteImport } from './routes/_public/discovery/steps/6/index'
import { Route as PublicDiscoverySteps7IndexRouteImport } from './routes/_public/discovery/steps/7/index'
import { Route as PublicDiscoverySteps8IndexRouteImport } from './routes/_public/discovery/steps/8/index'
import { Route as PublicDiscoverySteps9IndexRouteImport } from './routes/_public/discovery/steps/9/index'
import { Route as PublicDiscoveryStepsProcessingIndexRouteImport } from './routes/_public/discovery/steps/processing/index'
import { Route as PublicSummitSummitIdSessionSessionIdRouteImport } from './routes/_public/summit/$summitId/session/$sessionId'
import { Route as PublicWheelOfLifeResultsIdPrintRouteImport } from './routes/_public/wheel-of-life/results.$id_.print'
import { Route as UserMyCoachingBusinessCoursesCourseSlugRouteImport } from './routes/_user/my-coaching/business/courses/$courseSlug'
import { Route as UserMyCoachingBusinessLeadMagnetsIndexRouteImport } from './routes/_user/my-coaching/business/lead-magnets/index'
import { Route as UserMyCoachingBusinessLeadMagnetsLeadsRouteImport } from './routes/_user/my-coaching/business/lead-magnets/leads'
import { Route as UserMyCoachingBusinessNovaIndexRouteImport } from './routes/_user/my-coaching/business/nova/index'
import { Route as UserMyCoachingBusinessNovaConversationIdRouteImport } from './routes/_user/my-coaching/business/nova/$conversationId'
import { Route as UserMyCoachingBusinessNovaArchiveRouteImport } from './routes/_user/my-coaching/business/nova/archive'
import { Route as UserMyCoachingBusinessNovaAssetsRouteImport } from './routes/_user/my-coaching/business/nova/assets'
import { Route as UserMyCoachingBusinessNovaContentRouteImport } from './routes/_user/my-coaching/business/nova/content'
import { Route as UserMyCoachingBusinessNovaKnowsRouteImport } from './routes/_user/my-coaching/business/nova/knows'
import { Route as UserMyCoachingBusinessNovaRoutinesRouteImport } from './routes/_user/my-coaching/business/nova/routines'
import { Route as UserMyCoachingClientsProgramsIndexRouteImport } from './routes/_user/my-coaching/clients/programs/index'
import { Route as UserMyCoachingClientsProgramsEngagementIdRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId'
import { Route as UserMyCoachingClientsProgramsNewRouteImport } from './routes/_user/my-coaching/clients/programs/new'
import { Route as UserMyCoachingProfileOffersIndexRouteImport } from './routes/_user/my-coaching/profile/offers/index'
import { Route as UserMyCoachingProfileOffersOfferIdRouteImport } from './routes/_user/my-coaching/profile/offers/$offerId'
import { Route as UserMyOrganizationSlugPagesIndexRouteImport } from './routes/_user/my-organization/$slug/pages/index'
import { Route as UserMyOrganizationSlugPagesProgramIdRouteImport } from './routes/_user/my-organization/$slug/pages/$programId'
import { Route as UserSettingsProfileBillingChangeRouteImport } from './routes/_user/settings/profile/billing_.change'
import { Route as AdminCoursesCourseIdWeeksWeekIdRouteImport } from './routes/admin/courses/$courseId/weeks/$weekId'
import { Route as UserMyCoachingBusinessCoursesCourseSlugIndexRouteImport } from './routes/_user/my-coaching/business/courses/$courseSlug/index'
import { Route as UserMyCoachingBusinessLeadMagnetsLeadsIndexRouteImport } from './routes/_user/my-coaching/business/lead-magnets/leads/index'
import { Route as UserMyCoachingBusinessLeadMagnetsLeadsLeadIdRouteImport } from './routes/_user/my-coaching/business/lead-magnets/leads/$leadId'
import { Route as UserMyCoachingBusinessNovaAssetsIndexRouteImport } from './routes/_user/my-coaching/business/nova/assets/index'
import { Route as UserMyCoachingBusinessNovaAssetsAssetKeyRouteImport } from './routes/_user/my-coaching/business/nova/assets/$assetKey'
import { Route as UserMyCoachingBusinessNovaAssetsCheckInRouteImport } from './routes/_user/my-coaching/business/nova/assets/check-in'
import { Route as UserMyCoachingClientsProgramsEngagementIdIndexRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/index'
import { Route as UserMyCoachingClientsProgramsEngagementIdAdminRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/admin'
import { Route as UserMyCoachingClientsProgramsEngagementIdClientGoalsRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/client-goals'
import { Route as UserMyCoachingClientsProgramsEngagementIdClientVisionRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/client-vision'
import { Route as UserMyCoachingClientsProgramsEngagementIdCoachingGoalsAndOutcomesRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/coaching-goals-and-outcomes'
import { Route as UserMyCoachingClientsProgramsEngagementIdCoachingResourcesRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/coaching-resources'
import { Route as UserMyCoachingClientsProgramsEngagementIdHomeworkRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/homework'
import { Route as UserMyCoachingClientsProgramsEngagementIdMessagesRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/messages'
import { Route as UserMyCoachingClientsProgramsEngagementIdNotesRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/notes'
import { Route as UserMyCoachingClientsProgramsEngagementIdSessionsRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/sessions'
import { Route as PublicCoachesCitySlugCategoryCategorySlugIndexRouteImport } from './routes/_public/coaches/city/$slug/category/$categorySlug/index'
import { Route as PublicCoachesCitySlugSubcategorySubcategorySlugIndexRouteImport } from './routes/_public/coaches/city/$slug/subcategory/$subcategorySlug/index'
import { Route as UserMyCoachingBusinessCoursesCourseSlugWeeksWeekNumberRouteImport } from './routes/_user/my-coaching/business/courses/$courseSlug/weeks/$weekNumber'
import { Route as UserMyCoachingBusinessNovaAssetsAssetKeyIndexRouteImport } from './routes/_user/my-coaching/business/nova/assets/$assetKey/index'
import { Route as UserMyCoachingBusinessNovaAssetsAssetKeyItemIdRouteImport } from './routes/_user/my-coaching/business/nova/assets/$assetKey/$itemId'
import { Route as UserMyCoachingClientsProgramsEngagementIdVisionCategoryIdRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/vision.$categoryId'
import { Route as UserMyCoachingClientsProgramsEngagementIdWheelShareIdRouteImport } from './routes/_user/my-coaching/clients/programs/$engagementId/wheel.$shareId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UsernameRoute = UsernameRouteImport.update({
            id: '/$username',path: '/$username',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const UserRoute = UserRouteImport.update({
            id: '/_user',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const UsernameProfileRoute = UsernameProfileRouteImport.update({
            id: '/_profile',getParentRoute: () => UsernameRoute
          })
const UsernameOfferRoute = UsernameOfferRouteImport.update({
            id: '/offer',path: '/offer',getParentRoute: () => UsernameRoute
          })
const Public6FigureReadinessScoreRoute = Public6FigureReadinessScoreRouteImport.update({
            id: '/6-figure-readiness-score',path: '/6-figure-readiness-score',getParentRoute: () => PublicRoute
          })
const PublicAboutRoute = PublicAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => PublicRoute
          })
const PublicArticlesRoute = PublicArticlesRouteImport.update({
            id: '/articles',path: '/articles',getParentRoute: () => PublicRoute
          })
const PublicBrandRoute = PublicBrandRouteImport.update({
            id: '/brand',path: '/brand',getParentRoute: () => PublicRoute
          })
const PublicCoachBusinessBuilderRoute = PublicCoachBusinessBuilderRouteImport.update({
            id: '/coach-business-builder',path: '/coach-business-builder',getParentRoute: () => PublicRoute
          })
const PublicCoachingBusinessRoute = PublicCoachingBusinessRouteImport.update({
            id: '/coaching-business',path: '/coaching-business',getParentRoute: () => PublicRoute
          })
const PublicCoachingIntelligenceRoute = PublicCoachingIntelligenceRouteImport.update({
            id: '/coaching-intelligence',path: '/coaching-intelligence',getParentRoute: () => PublicRoute
          })
const PublicDcmVsBetterupRoute = PublicDcmVsBetterupRouteImport.update({
            id: '/dcm-vs-betterup',path: '/dcm-vs-betterup',getParentRoute: () => PublicRoute
          })
const PublicHowItWorksRoute = PublicHowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => PublicRoute
          })
const PublicOrganizationsRoute = PublicOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => PublicRoute
          })
const PublicOurCoachesRoute = PublicOurCoachesRouteImport.update({
            id: '/our-coaches',path: '/our-coaches',getParentRoute: () => PublicRoute
          })
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PublicRoute
          })
const PublicPrivacyPolicyRoute = PublicPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => PublicRoute
          })
const PublicTrainingProgramsRoute = PublicTrainingProgramsRouteImport.update({
            id: '/training-programs',path: '/training-programs',getParentRoute: () => PublicRoute
          })
const PublicVisionRoute = PublicVisionRouteImport.update({
            id: '/vision',path: '/vision',getParentRoute: () => PublicRoute
          })
const PublicWhatWeOfferRoute = PublicWhatWeOfferRouteImport.update({
            id: '/what-we-offer',path: '/what-we-offer',getParentRoute: () => PublicRoute
          })
const PublicWheelRoute = PublicWheelRouteImport.update({
            id: '/wheel',path: '/wheel',getParentRoute: () => PublicRoute
          })
const PublicWheelOfLifeRoute = PublicWheelOfLifeRouteImport.update({
            id: '/wheel-of-life',path: '/wheel-of-life',getParentRoute: () => PublicRoute
          })
const UserBecomeACoachRoute = UserBecomeACoachRouteImport.update({
            id: '/become-a-coach',path: '/become-a-coach',getParentRoute: () => UserRoute
          })
const UserCoachingRoute = UserCoachingRouteImport.update({
            id: '/coaching',path: '/coaching',getParentRoute: () => UserRoute
          })
const UserContactsRoute = UserContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => UserRoute
          })
const UserHelpRoute = UserHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => UserRoute
          })
const UserLifeDesignRoute = UserLifeDesignRouteImport.update({
            id: '/life-design',path: '/life-design',getParentRoute: () => UserRoute
          })
const UserMessagesRoute = UserMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => UserRoute
          })
const UserMyCoachingRoute = UserMyCoachingRouteImport.update({
            id: '/my-coaching',path: '/my-coaching',getParentRoute: () => UserRoute
          })
const UserMyOrganizationRoute = UserMyOrganizationRouteImport.update({
            id: '/my-organization',path: '/my-organization',getParentRoute: () => UserRoute
          })
const UserProPlusRoute = UserProPlusRouteImport.update({
            id: '/pro-plus',path: '/pro-plus',getParentRoute: () => UserRoute
          })
const UserReferralsRoute = UserReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => UserRoute
          })
const UserSettingsRoute = UserSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => UserRoute
          })
const UserSummitsRoute = UserSummitsRouteImport.update({
            id: '/summits',path: '/summits',getParentRoute: () => UserRoute
          })
const UserWelcomeRoute = UserWelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => UserRoute
          })
const AcceptInvitationIndexRoute = AcceptInvitationIndexRouteImport.update({
            id: '/accept-invitation/',path: '/accept-invitation/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminCihRoute = AdminCihRouteImport.update({
            id: '/cih',path: '/cih',getParentRoute: () => AdminRoute
          })
const AdminCoursesRoute = AdminCoursesRouteImport.update({
            id: '/courses',path: '/courses',getParentRoute: () => AdminRoute
          })
const AdminTransformationStoriesRoute = AdminTransformationStoriesRouteImport.update({
            id: '/transformation-stories',path: '/transformation-stories',getParentRoute: () => AdminRoute
          })
const AdminVideosRoute = AdminVideosRouteImport.update({
            id: '/videos',path: '/videos',getParentRoute: () => AdminRoute
          })
const CoachSplatRoute = CoachSplatRouteImport.update({
            id: '/coach/$',path: '/coach/$',getParentRoute: () => rootRouteImport
          })
const IntakeIndexRoute = IntakeIndexRouteImport.update({
            id: '/intake/',path: '/intake/',getParentRoute: () => rootRouteImport
          })
const SummitSpecialThankYouRoute = SummitSpecialThankYouRouteImport.update({
            id: '/summit-special/thank-you',path: '/summit-special/thank-you',getParentRoute: () => rootRouteImport
          })
const SummitIndexRoute = SummitIndexRouteImport.update({
            id: '/summit/',path: '/summit/',getParentRoute: () => rootRouteImport
          })
const SummitAgendaRoute = SummitAgendaRouteImport.update({
            id: '/summit/agenda',path: '/summit/agenda',getParentRoute: () => rootRouteImport
          })
const SummitRegisterRoute = SummitRegisterRouteImport.update({
            id: '/summit/register',path: '/summit/register',getParentRoute: () => rootRouteImport
          })
const SummitStreamRoute = SummitStreamRouteImport.update({
            id: '/summit/stream',path: '/summit/stream',getParentRoute: () => rootRouteImport
          })
const UsernameProfileIndexRoute = UsernameProfileIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UsernameProfileRoute
          })
const UsernameProfileResourcesRoute = UsernameProfileResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => UsernameProfileRoute
          })
const UsernameBookIndexRoute = UsernameBookIndexRouteImport.update({
            id: '/book/',path: '/book/',getParentRoute: () => UsernameRoute
          })
const UsernameContactIndexRoute = UsernameContactIndexRouteImport.update({
            id: '/contact/',path: '/contact/',getParentRoute: () => UsernameRoute
          })
const UsernameOfferIndexRoute = UsernameOfferIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UsernameOfferRoute
          })
const UsernameWheelOfLifeIndexRoute = UsernameWheelOfLifeIndexRouteImport.update({
            id: '/wheel-of-life/',path: '/wheel-of-life/',getParentRoute: () => UsernameRoute
          })
const AuthAcceptTokenIndexRoute = AuthAcceptTokenIndexRouteImport.update({
            id: '/accept-token/',path: '/accept-token/',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
            id: '/forgot-password/',path: '/forgot-password/',getParentRoute: () => AuthRoute
          })
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => AuthRoute
          })
const AuthSigninIndexRoute = AuthSigninIndexRouteImport.update({
            id: '/signin/',path: '/signin/',getParentRoute: () => AuthRoute
          })
const AuthSignupIndexRoute = AuthSignupIndexRouteImport.update({
            id: '/signup/',path: '/signup/',getParentRoute: () => AuthRoute
          })
const PublicAboutIndexRoute = PublicAboutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicAboutRoute
          })
const PublicAboutAdvisoryCouncilRoute = PublicAboutAdvisoryCouncilRouteImport.update({
            id: '/advisory-council',path: '/advisory-council',getParentRoute: () => PublicAboutRoute
          })
const PublicArticlesIndexRoute = PublicArticlesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicArticlesRoute
          })
const PublicArticlesSlugRoute = PublicArticlesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PublicArticlesRoute
          })
const PublicCcosIndexRoute = PublicCcosIndexRouteImport.update({
            id: '/ccos/',path: '/ccos/',getParentRoute: () => PublicRoute
          })
const PublicCoachesIndexRoute = PublicCoachesIndexRouteImport.update({
            id: '/coaches/',path: '/coaches/',getParentRoute: () => PublicRoute
          })
const PublicCoachingBusinessIndexRoute = PublicCoachingBusinessIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicCoachingBusinessRoute
          })
const PublicCoachingBusinessGuideSlugRoute = PublicCoachingBusinessGuideSlugRouteImport.update({
            id: '/$guideSlug',path: '/$guideSlug',getParentRoute: () => PublicCoachingBusinessRoute
          })
const PublicCoachingBusinessPlaybooksRoute = PublicCoachingBusinessPlaybooksRouteImport.update({
            id: '/playbooks',path: '/playbooks',getParentRoute: () => PublicCoachingBusinessRoute
          })
const PublicCoachingForIndexRoute = PublicCoachingForIndexRouteImport.update({
            id: '/coaching-for/',path: '/coaching-for/',getParentRoute: () => PublicRoute
          })
const PublicCoachingForChallengeSlugRoute = PublicCoachingForChallengeSlugRouteImport.update({
            id: '/coaching-for/$challengeSlug',path: '/coaching-for/$challengeSlug',getParentRoute: () => PublicRoute
          })
const PublicDiscoveryIndexRoute = PublicDiscoveryIndexRouteImport.update({
            id: '/discovery/',path: '/discovery/',getParentRoute: () => PublicRoute
          })
const PublicDiscoveryUsernameRoute = PublicDiscoveryUsernameRouteImport.update({
            id: '/discovery/$username',path: '/discovery/$username',getParentRoute: () => PublicRoute
          })
const PublicDiscoveryMatchRoute = PublicDiscoveryMatchRouteImport.update({
            id: '/discovery/match',path: '/discovery/match',getParentRoute: () => PublicRoute
          })
const PublicDiscoveryRefineRoute = PublicDiscoveryRefineRouteImport.update({
            id: '/discovery/refine',path: '/discovery/refine',getParentRoute: () => PublicRoute
          })
const PublicDiscoveryResultsRoute = PublicDiscoveryResultsRouteImport.update({
            id: '/discovery/results',path: '/discovery/results',getParentRoute: () => PublicRoute
          })
const PublicDiscoveryStepsRoute = PublicDiscoveryStepsRouteImport.update({
            id: '/discovery/steps',path: '/discovery/steps',getParentRoute: () => PublicRoute
          })
const PublicFrameworksIndexRoute = PublicFrameworksIndexRouteImport.update({
            id: '/frameworks/',path: '/frameworks/',getParentRoute: () => PublicRoute
          })
const PublicFrameworksSlugRoute = PublicFrameworksSlugRouteImport.update({
            id: '/frameworks/$slug',path: '/frameworks/$slug',getParentRoute: () => PublicRoute
          })
const PublicGoalsShareSlugRoute = PublicGoalsShareSlugRouteImport.update({
            id: '/goals/$shareSlug',path: '/goals/$shareSlug',getParentRoute: () => PublicRoute
          })
const PublicOrganizationInviteTokenRoute = PublicOrganizationInviteTokenRouteImport.update({
            id: '/organization-invite/$token',path: '/organization-invite/$token',getParentRoute: () => PublicRoute
          })
const PublicOrganizationsIndexRoute = PublicOrganizationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicOrganizationsRoute
          })
const PublicOrganizationsSlugRoute = PublicOrganizationsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PublicOrganizationsRoute
          })
const PublicStoriesIndexRoute = PublicStoriesIndexRouteImport.update({
            id: '/stories/',path: '/stories/',getParentRoute: () => PublicRoute
          })
const PublicSummitDebugRoute = PublicSummitDebugRouteImport.update({
            id: '/summit/debug',path: '/summit/debug',getParentRoute: () => PublicRoute
          })
const PublicTrainingProgramsIndexRoute = PublicTrainingProgramsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicTrainingProgramsRoute
          })
const PublicTrainingProgramsSlugRoute = PublicTrainingProgramsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PublicTrainingProgramsRoute
          })
const PublicWIdRoute = PublicWIdRouteImport.update({
            id: '/w/$id',path: '/w/$id',getParentRoute: () => PublicRoute
          })
const PublicWheelOfLifeIndexRoute = PublicWheelOfLifeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicWheelOfLifeRoute
          })
const PublicWheelOfLifeTemplateRoute = PublicWheelOfLifeTemplateRouteImport.update({
            id: '/template',path: '/template',getParentRoute: () => PublicWheelOfLifeRoute
          })
const UserCoachDiscoveryIndexRoute = UserCoachDiscoveryIndexRouteImport.update({
            id: '/coach-discovery/',path: '/coach-discovery/',getParentRoute: () => UserRoute
          })
const UserCoachFinderIndexRoute = UserCoachFinderIndexRouteImport.update({
            id: '/coach-finder/',path: '/coach-finder/',getParentRoute: () => UserRoute
          })
const UserCoachingIndexRoute = UserCoachingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserCoachingRoute
          })
const UserCoachingEngagementIdRoute = UserCoachingEngagementIdRouteImport.update({
            id: '/$engagementId',path: '/$engagementId',getParentRoute: () => UserCoachingRoute
          })
const UserContactsIndexRoute = UserContactsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserContactsRoute
          })
const UserDashboardIndexRoute = UserDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => UserRoute
          })
const UserLifeDesignIndexRoute = UserLifeDesignIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserLifeDesignRoute
          })
const UserLifeDesignCategoryIdRoute = UserLifeDesignCategoryIdRouteImport.update({
            id: '/$categoryId',path: '/$categoryId',getParentRoute: () => UserLifeDesignRoute
          })
const UserLifeDesignGoalsRoute = UserLifeDesignGoalsRouteImport.update({
            id: '/goals',path: '/goals',getParentRoute: () => UserLifeDesignRoute
          })
const UserLifeDesignNewCategoryRoute = UserLifeDesignNewCategoryRouteImport.update({
            id: '/new-category',path: '/new-category',getParentRoute: () => UserLifeDesignRoute
          })
const UserLifeDesignOverallVisionRoute = UserLifeDesignOverallVisionRouteImport.update({
            id: '/overall-vision',path: '/overall-vision',getParentRoute: () => UserLifeDesignRoute
          })
const UserMessagesIndexRoute = UserMessagesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMessagesRoute
          })
const UserMyCoachingIndexRoute = UserMyCoachingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingAcceleratorRoute = UserMyCoachingAcceleratorRouteImport.update({
            id: '/accelerator',path: '/accelerator',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingArticlesRoute = UserMyCoachingArticlesRouteImport.update({
            id: '/articles',path: '/articles',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingProfileRoute = UserMyCoachingProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingReferralsRoute = UserMyCoachingReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingStripeConnectRoute = UserMyCoachingStripeConnectRouteImport.update({
            id: '/stripe-connect',path: '/stripe-connect',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingWelcomeRoute = UserMyCoachingWelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingWhatsComingRoute = UserMyCoachingWhatsComingRouteImport.update({
            id: '/whats-coming',path: '/whats-coming',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingWhatsNewRoute = UserMyCoachingWhatsNewRouteImport.update({
            id: '/whats-new',path: '/whats-new',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyOrganizationIndexRoute = UserMyOrganizationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyOrganizationRoute
          })
const UserMyOrganizationSlugRoute = UserMyOrganizationSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => UserMyOrganizationRoute
          })
const UserSettingsIndexRoute = UserSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserSettingsRoute
          })
const UserSettingsProfileRoute = UserSettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => UserSettingsRoute
          })
const UserSummitsIndexRoute = UserSummitsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserSummitsRoute
          })
const AdminCallsAndLinksIndexRoute = AdminCallsAndLinksIndexRouteImport.update({
            id: '/calls-and-links/',path: '/calls-and-links/',getParentRoute: () => AdminRoute
          })
const AdminCihIndexRoute = AdminCihIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminCihRoute
          })
const AdminCihPageChangesRoute = AdminCihPageChangesRouteImport.update({
            id: '/page-changes',path: '/page-changes',getParentRoute: () => AdminCihRoute
          })
const AdminCihStoriesRoute = AdminCihStoriesRouteImport.update({
            id: '/stories',path: '/stories',getParentRoute: () => AdminCihRoute
          })
const AdminCoachesIndexRoute = AdminCoachesIndexRouteImport.update({
            id: '/coaches/',path: '/coaches/',getParentRoute: () => AdminRoute
          })
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminCoursesRoute
          })
const AdminCoursesCourseIdRoute = AdminCoursesCourseIdRouteImport.update({
            id: '/$courseId',path: '/$courseId',getParentRoute: () => AdminCoursesRoute
          })
const AdminCtpsIndexRoute = AdminCtpsIndexRouteImport.update({
            id: '/ctps/',path: '/ctps/',getParentRoute: () => AdminRoute
          })
const AdminFeatureFlagsIndexRoute = AdminFeatureFlagsIndexRouteImport.update({
            id: '/feature-flags/',path: '/feature-flags/',getParentRoute: () => AdminRoute
          })
const AdminFeatureVotesIndexRoute = AdminFeatureVotesIndexRouteImport.update({
            id: '/feature-votes/',path: '/feature-votes/',getParentRoute: () => AdminRoute
          })
const AdminFeeExemptionsIndexRoute = AdminFeeExemptionsIndexRouteImport.update({
            id: '/fee-exemptions/',path: '/fee-exemptions/',getParentRoute: () => AdminRoute
          })
const AdminFunnelHealthIndexRoute = AdminFunnelHealthIndexRouteImport.update({
            id: '/funnel-health/',path: '/funnel-health/',getParentRoute: () => AdminRoute
          })
const AdminIntegrationsIndexRoute = AdminIntegrationsIndexRouteImport.update({
            id: '/integrations/',path: '/integrations/',getParentRoute: () => AdminRoute
          })
const AdminMpaiIndexRoute = AdminMpaiIndexRouteImport.update({
            id: '/mpai/',path: '/mpai/',getParentRoute: () => AdminRoute
          })
const AdminNovaUsageIndexRoute = AdminNovaUsageIndexRouteImport.update({
            id: '/nova-usage/',path: '/nova-usage/',getParentRoute: () => AdminRoute
          })
const AdminReferralRewardsIndexRoute = AdminReferralRewardsIndexRouteImport.update({
            id: '/referral-rewards/',path: '/referral-rewards/',getParentRoute: () => AdminRoute
          })
const AdminSummitCtaIndexRoute = AdminSummitCtaIndexRouteImport.update({
            id: '/summit-cta/',path: '/summit-cta/',getParentRoute: () => AdminRoute
          })
const AdminSummitSessionsIndexRoute = AdminSummitSessionsIndexRouteImport.update({
            id: '/summit-sessions/',path: '/summit-sessions/',getParentRoute: () => AdminRoute
          })
const AdminSummitSessionsSessionIdRoute = AdminSummitSessionsSessionIdRouteImport.update({
            id: '/summit-sessions/$sessionId',path: '/summit-sessions/$sessionId',getParentRoute: () => AdminRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => AdminRoute
          })
const AdminVerificationsIndexRoute = AdminVerificationsIndexRouteImport.update({
            id: '/verifications/',path: '/verifications/',getParentRoute: () => AdminRoute
          })
const AdminVideosIndexRoute = AdminVideosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminVideosRoute
          })
const AdminVideosPlacementsRoute = AdminVideosPlacementsRouteImport.update({
            id: '/placements',path: '/placements',getParentRoute: () => AdminVideosRoute
          })
const AdminWhatsNewIndexRoute = AdminWhatsNewIndexRouteImport.update({
            id: '/whats-new/',path: '/whats-new/',getParentRoute: () => AdminRoute
          })
const ApiGhlSetUserPermissionsIndexRoute = ApiGhlSetUserPermissionsIndexRouteImport.update({
            id: '/api/ghl-set-user-permissions/',path: '/api/ghl-set-user-permissions/',getParentRoute: () => rootRouteImport
          })
const EmbedAppointmentsChartIndexRoute = EmbedAppointmentsChartIndexRouteImport.update({
            id: '/embed/appointments-chart/',path: '/embed/appointments-chart/',getParentRoute: () => rootRouteImport
          })
const EmbedCoachDashboardIndexRoute = EmbedCoachDashboardIndexRouteImport.update({
            id: '/embed/coach-dashboard/',path: '/embed/coach-dashboard/',getParentRoute: () => rootRouteImport
          })
const EmbedCoachLevelsIndexRoute = EmbedCoachLevelsIndexRouteImport.update({
            id: '/embed/coach-levels/',path: '/embed/coach-levels/',getParentRoute: () => rootRouteImport
          })
const EmbedCoachesChartIndexRoute = EmbedCoachesChartIndexRouteImport.update({
            id: '/embed/coaches-chart/',path: '/embed/coaches-chart/',getParentRoute: () => rootRouteImport
          })
const EmbedDiscoveryChartIndexRoute = EmbedDiscoveryChartIndexRouteImport.update({
            id: '/embed/discovery-chart/',path: '/embed/discovery-chart/',getParentRoute: () => rootRouteImport
          })
const EmbedDiscoveryEligibleCoachesIndexRoute = EmbedDiscoveryEligibleCoachesIndexRouteImport.update({
            id: '/embed/discovery-eligible-coaches/',path: '/embed/discovery-eligible-coaches/',getParentRoute: () => rootRouteImport
          })
const EmbedEngagementsChartIndexRoute = EmbedEngagementsChartIndexRouteImport.update({
            id: '/embed/engagements-chart/',path: '/embed/engagements-chart/',getParentRoute: () => rootRouteImport
          })
const EmbedIntakeChartIndexRoute = EmbedIntakeChartIndexRouteImport.update({
            id: '/embed/intake-chart/',path: '/embed/intake-chart/',getParentRoute: () => rootRouteImport
          })
const EmbedNewCoaches30dIndexRoute = EmbedNewCoaches30dIndexRouteImport.update({
            id: '/embed/new-coaches-30d/',path: '/embed/new-coaches-30d/',getParentRoute: () => rootRouteImport
          })
const EmbedNumberOfAppointmentsIndexRoute = EmbedNumberOfAppointmentsIndexRouteImport.update({
            id: '/embed/number-of-appointments/',path: '/embed/number-of-appointments/',getParentRoute: () => rootRouteImport
          })
const EmbedNumberOfCoachesIndexRoute = EmbedNumberOfCoachesIndexRouteImport.update({
            id: '/embed/number-of-coaches/',path: '/embed/number-of-coaches/',getParentRoute: () => rootRouteImport
          })
const EmbedNumberOfUsersIndexRoute = EmbedNumberOfUsersIndexRouteImport.update({
            id: '/embed/number-of-users/',path: '/embed/number-of-users/',getParentRoute: () => rootRouteImport
          })
const EmbedSessionsChartIndexRoute = EmbedSessionsChartIndexRouteImport.update({
            id: '/embed/sessions-chart/',path: '/embed/sessions-chart/',getParentRoute: () => rootRouteImport
          })
const EmbedUsersChartIndexRoute = EmbedUsersChartIndexRouteImport.update({
            id: '/embed/users-chart/',path: '/embed/users-chart/',getParentRoute: () => rootRouteImport
          })
const SummitSpecialCheckoutOfferIdRoute = SummitSpecialCheckoutOfferIdRouteImport.update({
            id: '/summit-special/checkout/$offerId',path: '/summit-special/checkout/$offerId',getParentRoute: () => rootRouteImport
          })
const SummitSummitIdAgendaRoute = SummitSummitIdAgendaRouteImport.update({
            id: '/summit/$summitId/agenda',path: '/summit/$summitId/agenda',getParentRoute: () => rootRouteImport
          })
const SummitDayNumberRoute = SummitDayNumberRouteImport.update({
            id: '/summit/day/$number',path: '/summit/day/$number',getParentRoute: () => rootRouteImport
          })
const UsernameProfileResourcesIndexRoute = UsernameProfileResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UsernameProfileResourcesRoute
          })
const UsernameOfferOfferIdIndexRoute = UsernameOfferOfferIdIndexRouteImport.update({
            id: '/$offerId/',path: '/$offerId/',getParentRoute: () => UsernameOfferRoute
          })
const UsernameWheelOfLifeResultsIdRoute = UsernameWheelOfLifeResultsIdRouteImport.update({
            id: '/wheel-of-life/results/$id',path: '/wheel-of-life/results/$id',getParentRoute: () => UsernameRoute
          })
const PublicBrandComponentsIndexRoute = PublicBrandComponentsIndexRouteImport.update({
            id: '/components/',path: '/components/',getParentRoute: () => PublicBrandRoute
          })
const PublicBrandGuidelineIndexRoute = PublicBrandGuidelineIndexRouteImport.update({
            id: '/guideline/',path: '/guideline/',getParentRoute: () => PublicBrandRoute
          })
const PublicCoachesCategoryIndexRoute = PublicCoachesCategoryIndexRouteImport.update({
            id: '/coaches/category/',path: '/coaches/category/',getParentRoute: () => PublicRoute
          })
const PublicCoachesCcoIndexRoute = PublicCoachesCcoIndexRouteImport.update({
            id: '/coaches/cco/',path: '/coaches/cco/',getParentRoute: () => PublicRoute
          })
const PublicCoachesCityIndexRoute = PublicCoachesCityIndexRouteImport.update({
            id: '/coaches/city/',path: '/coaches/city/',getParentRoute: () => PublicRoute
          })
const PublicCoachesCtpIndexRoute = PublicCoachesCtpIndexRouteImport.update({
            id: '/coaches/ctp/',path: '/coaches/ctp/',getParentRoute: () => PublicRoute
          })
const PublicCoachesCtpSlugRoute = PublicCoachesCtpSlugRouteImport.update({
            id: '/coaches/ctp/$slug',path: '/coaches/ctp/$slug',getParentRoute: () => PublicRoute
          })
const PublicCoachesFoundingIndexRoute = PublicCoachesFoundingIndexRouteImport.update({
            id: '/coaches/founding/',path: '/coaches/founding/',getParentRoute: () => PublicRoute
          })
const PublicCoachesSubcategoryIndexRoute = PublicCoachesSubcategoryIndexRouteImport.update({
            id: '/coaches/subcategory/',path: '/coaches/subcategory/',getParentRoute: () => PublicRoute
          })
const PublicCoachingBusinessPlaybooksIndexRoute = PublicCoachingBusinessPlaybooksIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicCoachingBusinessPlaybooksRoute
          })
const PublicCoachingBusinessPlaybooksSlugRoute = PublicCoachingBusinessPlaybooksSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PublicCoachingBusinessPlaybooksRoute
          })
const PublicCoachingForChallengeSlugIndexRoute = PublicCoachingForChallengeSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicCoachingForChallengeSlugRoute
          })
const PublicCoachingForChallengeSlugArticlesRoute = PublicCoachingForChallengeSlugArticlesRouteImport.update({
            id: '/articles',path: '/articles',getParentRoute: () => PublicCoachingForChallengeSlugRoute
          })
const PublicCoachingForChallengeSlugCoachesRoute = PublicCoachingForChallengeSlugCoachesRouteImport.update({
            id: '/coaches',path: '/coaches',getParentRoute: () => PublicCoachingForChallengeSlugRoute
          })
const PublicDiscoveryUsernameIndexRoute = PublicDiscoveryUsernameIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicDiscoveryUsernameRoute
          })
const PublicDiscoveryMatchIndexRoute = PublicDiscoveryMatchIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicDiscoveryMatchRoute
          })
const PublicDiscoveryMatchContextRoute = PublicDiscoveryMatchContextRouteImport.update({
            id: '/context',path: '/context',getParentRoute: () => PublicDiscoveryMatchRoute
          })
const PublicDiscoveryRefineIndexRoute = PublicDiscoveryRefineIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicDiscoveryRefineRoute
          })
const PublicDiscoveryRefineFitRoute = PublicDiscoveryRefineFitRouteImport.update({
            id: '/fit',path: '/fit',getParentRoute: () => PublicDiscoveryRefineRoute
          })
const PublicDiscoveryRefineLogisticsRoute = PublicDiscoveryRefineLogisticsRouteImport.update({
            id: '/logistics',path: '/logistics',getParentRoute: () => PublicDiscoveryRefineRoute
          })
const PublicDiscoveryStepsIndexRoute = PublicDiscoveryStepsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicFrameworksSlugIndexRoute = PublicFrameworksSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicFrameworksSlugRoute
          })
const PublicFrameworksSlugCoachesRoute = PublicFrameworksSlugCoachesRouteImport.update({
            id: '/coaches',path: '/coaches',getParentRoute: () => PublicFrameworksSlugRoute
          })
const PublicFrameworksSlugTrainingProgramsRoute = PublicFrameworksSlugTrainingProgramsRouteImport.update({
            id: '/training-programs',path: '/training-programs',getParentRoute: () => PublicFrameworksSlugRoute
          })
const PublicOrganizationsSlugIndexRoute = PublicOrganizationsSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicOrganizationsSlugRoute
          })
const PublicOrganizationsSlugClaimRoute = PublicOrganizationsSlugClaimRouteImport.update({
            id: '/claim',path: '/claim',getParentRoute: () => PublicOrganizationsSlugRoute
          })
const PublicOrganizationsSlugCoachesRoute = PublicOrganizationsSlugCoachesRouteImport.update({
            id: '/coaches',path: '/coaches',getParentRoute: () => PublicOrganizationsSlugRoute
          })
const PublicOrganizationsSlugJoinRoute = PublicOrganizationsSlugJoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => PublicOrganizationsSlugRoute
          })
const PublicOrganizationsSlugTrainingProgramsRoute = PublicOrganizationsSlugTrainingProgramsRouteImport.update({
            id: '/training-programs',path: '/training-programs',getParentRoute: () => PublicOrganizationsSlugRoute
          })
const PublicPageNameIndexRoute = PublicPageNameIndexRouteImport.update({
            id: '/page/$name/',path: '/page/$name/',getParentRoute: () => PublicRoute
          })
const PublicSummitSummitIdRecapRoute = PublicSummitSummitIdRecapRouteImport.update({
            id: '/summit/$summitId/recap',path: '/summit/$summitId/recap',getParentRoute: () => PublicRoute
          })
const PublicTrainingProgramsSlugIndexRoute = PublicTrainingProgramsSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicTrainingProgramsSlugRoute
          })
const PublicTrainingProgramsSlugCoachesRoute = PublicTrainingProgramsSlugCoachesRouteImport.update({
            id: '/coaches',path: '/coaches',getParentRoute: () => PublicTrainingProgramsSlugRoute
          })
const PublicWheelOfLifeResultsIdRoute = PublicWheelOfLifeResultsIdRouteImport.update({
            id: '/results/$id',path: '/results/$id',getParentRoute: () => PublicWheelOfLifeRoute
          })
const UserCoachingEngagementIdIndexRoute = UserCoachingEngagementIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserCoachingEngagementIdRoute
          })
const UserCoachingEngagementIdAdminRoute = UserCoachingEngagementIdAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => UserCoachingEngagementIdRoute
          })
const UserCoachingEngagementIdCoachingGoalsAndOutcomesRoute = UserCoachingEngagementIdCoachingGoalsAndOutcomesRouteImport.update({
            id: '/coaching-goals-and-outcomes',path: '/coaching-goals-and-outcomes',getParentRoute: () => UserCoachingEngagementIdRoute
          })
const UserCoachingEngagementIdCoachingResourcesRoute = UserCoachingEngagementIdCoachingResourcesRouteImport.update({
            id: '/coaching-resources',path: '/coaching-resources',getParentRoute: () => UserCoachingEngagementIdRoute
          })
const UserCoachingEngagementIdHomeworkRoute = UserCoachingEngagementIdHomeworkRouteImport.update({
            id: '/homework',path: '/homework',getParentRoute: () => UserCoachingEngagementIdRoute
          })
const UserCoachingEngagementIdMessagesRoute = UserCoachingEngagementIdMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => UserCoachingEngagementIdRoute
          })
const UserCoachingEngagementIdNotesRoute = UserCoachingEngagementIdNotesRouteImport.update({
            id: '/notes',path: '/notes',getParentRoute: () => UserCoachingEngagementIdRoute
          })
const UserCoachingEngagementIdSessionsRoute = UserCoachingEngagementIdSessionsRouteImport.update({
            id: '/sessions',path: '/sessions',getParentRoute: () => UserCoachingEngagementIdRoute
          })
const UserCoachingEngagementIdWelcomeRoute = UserCoachingEngagementIdWelcomeRouteImport.update({
            id: '/$engagementId_/welcome',path: '/$engagementId/welcome',getParentRoute: () => UserCoachingRoute
          })
const UserMessagesConversationIdIndexRoute = UserMessagesConversationIdIndexRouteImport.update({
            id: '/$conversationId/',path: '/$conversationId/',getParentRoute: () => UserMessagesRoute
          })
const UserMyCoachingArticlesIndexRoute = UserMyCoachingArticlesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingArticlesRoute
          })
const UserMyCoachingArticlesArticleIdRoute = UserMyCoachingArticlesArticleIdRouteImport.update({
            id: '/$articleId',path: '/$articleId',getParentRoute: () => UserMyCoachingArticlesRoute
          })
const UserMyCoachingArticlesNewRoute = UserMyCoachingArticlesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => UserMyCoachingArticlesRoute
          })
const UserMyCoachingBusinessLeadMagnetsRoute = UserMyCoachingBusinessLeadMagnetsRouteImport.update({
            id: '/business/lead-magnets',path: '/business/lead-magnets',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingBusinessMarketingSuiteRoute = UserMyCoachingBusinessMarketingSuiteRouteImport.update({
            id: '/business/marketing-suite',path: '/business/marketing-suite',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingBusinessNovaRoute = UserMyCoachingBusinessNovaRouteImport.update({
            id: '/business/nova',path: '/business/nova',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingBusinessReadinessScoreRoute = UserMyCoachingBusinessReadinessScoreRouteImport.update({
            id: '/business/readiness-score',path: '/business/readiness-score',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingBusinessReadingRoute = UserMyCoachingBusinessReadingRouteImport.update({
            id: '/business/reading',path: '/business/reading',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingClientsDashboardRoute = UserMyCoachingClientsDashboardRouteImport.update({
            id: '/clients/dashboard',path: '/clients/dashboard',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingClientsInvoicesRoute = UserMyCoachingClientsInvoicesRouteImport.update({
            id: '/clients/invoices',path: '/clients/invoices',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingClientsProgramsRoute = UserMyCoachingClientsProgramsRouteImport.update({
            id: '/clients/programs',path: '/clients/programs',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingProfileBioRoute = UserMyCoachingProfileBioRouteImport.update({
            id: '/bio',path: '/bio',getParentRoute: () => UserMyCoachingProfileRoute
          })
const UserMyCoachingProfileDetailsRoute = UserMyCoachingProfileDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => UserMyCoachingProfileRoute
          })
const UserMyCoachingProfileOffersRoute = UserMyCoachingProfileOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => UserMyCoachingProfileRoute
          })
const UserMyCoachingProfilePersonalInfoRoute = UserMyCoachingProfilePersonalInfoRouteImport.update({
            id: '/personal-info',path: '/personal-info',getParentRoute: () => UserMyCoachingProfileRoute
          })
const UserMyCoachingProfileQualificationsRoute = UserMyCoachingProfileQualificationsRouteImport.update({
            id: '/qualifications',path: '/qualifications',getParentRoute: () => UserMyCoachingProfileRoute
          })
const UserMyCoachingProfileTestimonialsRoute = UserMyCoachingProfileTestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => UserMyCoachingProfileRoute
          })
const UserMyOrganizationSlugIndexRoute = UserMyOrganizationSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyOrganizationSlugRoute
          })
const UserMyOrganizationSlugClaimsRoute = UserMyOrganizationSlugClaimsRouteImport.update({
            id: '/claims',path: '/claims',getParentRoute: () => UserMyOrganizationSlugRoute
          })
const UserMyOrganizationSlugGraduatesRoute = UserMyOrganizationSlugGraduatesRouteImport.update({
            id: '/graduates',path: '/graduates',getParentRoute: () => UserMyOrganizationSlugRoute
          })
const UserMyOrganizationSlugInviteRoute = UserMyOrganizationSlugInviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => UserMyOrganizationSlugRoute
          })
const UserMyOrganizationSlugPagesRoute = UserMyOrganizationSlugPagesRouteImport.update({
            id: '/pages',path: '/pages',getParentRoute: () => UserMyOrganizationSlugRoute
          })
const UserSettingsAccountIndexRoute = UserSettingsAccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => UserSettingsRoute
          })
const UserSettingsCalendarIndexRoute = UserSettingsCalendarIndexRouteImport.update({
            id: '/calendar/',path: '/calendar/',getParentRoute: () => UserSettingsRoute
          })
const UserSettingsPasswordIndexRoute = UserSettingsPasswordIndexRouteImport.update({
            id: '/password/',path: '/password/',getParentRoute: () => UserSettingsRoute
          })
const UserSettingsProfileIndexRoute = UserSettingsProfileIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserSettingsProfileRoute
          })
const UserSettingsProfileBillingRoute = UserSettingsProfileBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => UserSettingsProfileRoute
          })
const UserSettingsProfileCoachingPreferencesRoute = UserSettingsProfileCoachingPreferencesRouteImport.update({
            id: '/coaching-preferences',path: '/coaching-preferences',getParentRoute: () => UserSettingsProfileRoute
          })
const UserSettingsProfilePasswordSettingsRoute = UserSettingsProfilePasswordSettingsRouteImport.update({
            id: '/password-settings',path: '/password-settings',getParentRoute: () => UserSettingsProfileRoute
          })
const AdminCihArticlesIndexRoute = AdminCihArticlesIndexRouteImport.update({
            id: '/articles/',path: '/articles/',getParentRoute: () => AdminCihRoute
          })
const AdminCihArticlesArticleIdRoute = AdminCihArticlesArticleIdRouteImport.update({
            id: '/articles/$articleId',path: '/articles/$articleId',getParentRoute: () => AdminCihRoute
          })
const AdminCihArticlesNewRoute = AdminCihArticlesNewRouteImport.update({
            id: '/articles/new',path: '/articles/new',getParentRoute: () => AdminCihRoute
          })
const AdminCihCcosIndexRoute = AdminCihCcosIndexRouteImport.update({
            id: '/ccos/',path: '/ccos/',getParentRoute: () => AdminCihRoute
          })
const AdminCihCcosCcoIdRoute = AdminCihCcosCcoIdRouteImport.update({
            id: '/ccos/$ccoId',path: '/ccos/$ccoId',getParentRoute: () => AdminCihRoute
          })
const AdminCihChallengesIndexRoute = AdminCihChallengesIndexRouteImport.update({
            id: '/challenges/',path: '/challenges/',getParentRoute: () => AdminCihRoute
          })
const AdminCihChallengesChallengeIdRoute = AdminCihChallengesChallengeIdRouteImport.update({
            id: '/challenges/$challengeId',path: '/challenges/$challengeId',getParentRoute: () => AdminCihRoute
          })
const AdminCihCtpsIndexRoute = AdminCihCtpsIndexRouteImport.update({
            id: '/ctps/',path: '/ctps/',getParentRoute: () => AdminCihRoute
          })
const AdminCihCtpsCtpIdRoute = AdminCihCtpsCtpIdRouteImport.update({
            id: '/ctps/$ctpId',path: '/ctps/$ctpId',getParentRoute: () => AdminCihRoute
          })
const AdminCihFrameworksIndexRoute = AdminCihFrameworksIndexRouteImport.update({
            id: '/frameworks/',path: '/frameworks/',getParentRoute: () => AdminCihRoute
          })
const AdminCihFrameworksFrameworkIdRoute = AdminCihFrameworksFrameworkIdRouteImport.update({
            id: '/frameworks/$frameworkId',path: '/frameworks/$frameworkId',getParentRoute: () => AdminCihRoute
          })
const AdminCihGuidesIndexRoute = AdminCihGuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => AdminCihRoute
          })
const AdminCihGuidesGuideIdRoute = AdminCihGuidesGuideIdRouteImport.update({
            id: '/guides/$guideId',path: '/guides/$guideId',getParentRoute: () => AdminCihRoute
          })
const AdminCihPlaybooksIndexRoute = AdminCihPlaybooksIndexRouteImport.update({
            id: '/playbooks/',path: '/playbooks/',getParentRoute: () => AdminCihRoute
          })
const AdminCihPlaybooksPlaybookIdRoute = AdminCihPlaybooksPlaybookIdRouteImport.update({
            id: '/playbooks/$playbookId',path: '/playbooks/$playbookId',getParentRoute: () => AdminCihRoute
          })
const AdminCihStoriesIndexRoute = AdminCihStoriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminCihStoriesRoute
          })
const AdminCihStoriesStoryIdRoute = AdminCihStoriesStoryIdRouteImport.update({
            id: '/$storyId',path: '/$storyId',getParentRoute: () => AdminCihStoriesRoute
          })
const AdminCihThoughtLeadersIndexRoute = AdminCihThoughtLeadersIndexRouteImport.update({
            id: '/thought-leaders/',path: '/thought-leaders/',getParentRoute: () => AdminCihRoute
          })
const AdminCihThoughtLeadersThoughtLeaderIdRoute = AdminCihThoughtLeadersThoughtLeaderIdRouteImport.update({
            id: '/thought-leaders/$thoughtLeaderId',path: '/thought-leaders/$thoughtLeaderId',getParentRoute: () => AdminCihRoute
          })
const AdminCoursesCourseIdIndexRoute = AdminCoursesCourseIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminCoursesCourseIdRoute
          })
const UsernameProfileResourcesResourceIdIndexRoute = UsernameProfileResourcesResourceIdIndexRouteImport.update({
            id: '/$resourceId/',path: '/$resourceId/',getParentRoute: () => UsernameProfileResourcesRoute
          })
const UsernameWheelOfLifeResultsIdPrintRoute = UsernameWheelOfLifeResultsIdPrintRouteImport.update({
            id: '/wheel-of-life/results/$id_/print',path: '/wheel-of-life/results/$id/print',getParentRoute: () => UsernameRoute
          })
const PublicCoachesCategoryCategorySlugIndexRoute = PublicCoachesCategoryCategorySlugIndexRouteImport.update({
            id: '/coaches/category/$categorySlug/',path: '/coaches/category/$categorySlug/',getParentRoute: () => PublicRoute
          })
const PublicCoachesCcoSlugIndexRoute = PublicCoachesCcoSlugIndexRouteImport.update({
            id: '/coaches/cco/$slug/',path: '/coaches/cco/$slug/',getParentRoute: () => PublicRoute
          })
const PublicCoachesCitySlugIndexRoute = PublicCoachesCitySlugIndexRouteImport.update({
            id: '/coaches/city/$slug/',path: '/coaches/city/$slug/',getParentRoute: () => PublicRoute
          })
const PublicCoachesSubcategorySubcategorySlugIndexRoute = PublicCoachesSubcategorySubcategorySlugIndexRouteImport.update({
            id: '/coaches/subcategory/$subcategorySlug/',path: '/coaches/subcategory/$subcategorySlug/',getParentRoute: () => PublicRoute
          })
const PublicDiscoveryUsernameBookIndexRoute = PublicDiscoveryUsernameBookIndexRouteImport.update({
            id: '/book/',path: '/book/',getParentRoute: () => PublicDiscoveryUsernameRoute
          })
const PublicDiscoveryUsernameOfferIndexRoute = PublicDiscoveryUsernameOfferIndexRouteImport.update({
            id: '/offer/',path: '/offer/',getParentRoute: () => PublicDiscoveryUsernameRoute
          })
const PublicDiscoveryUsernameResourcesIndexRoute = PublicDiscoveryUsernameResourcesIndexRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => PublicDiscoveryUsernameRoute
          })
const PublicDiscoverySteps1IndexRoute = PublicDiscoverySteps1IndexRouteImport.update({
            id: '/1/',path: '/1/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps10IndexRoute = PublicDiscoverySteps10IndexRouteImport.update({
            id: '/10/',path: '/10/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps2IndexRoute = PublicDiscoverySteps2IndexRouteImport.update({
            id: '/2/',path: '/2/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps3IndexRoute = PublicDiscoverySteps3IndexRouteImport.update({
            id: '/3/',path: '/3/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps4IndexRoute = PublicDiscoverySteps4IndexRouteImport.update({
            id: '/4/',path: '/4/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps5IndexRoute = PublicDiscoverySteps5IndexRouteImport.update({
            id: '/5/',path: '/5/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps6IndexRoute = PublicDiscoverySteps6IndexRouteImport.update({
            id: '/6/',path: '/6/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps7IndexRoute = PublicDiscoverySteps7IndexRouteImport.update({
            id: '/7/',path: '/7/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps8IndexRoute = PublicDiscoverySteps8IndexRouteImport.update({
            id: '/8/',path: '/8/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoverySteps9IndexRoute = PublicDiscoverySteps9IndexRouteImport.update({
            id: '/9/',path: '/9/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicDiscoveryStepsProcessingIndexRoute = PublicDiscoveryStepsProcessingIndexRouteImport.update({
            id: '/processing/',path: '/processing/',getParentRoute: () => PublicDiscoveryStepsRoute
          })
const PublicSummitSummitIdSessionSessionIdRoute = PublicSummitSummitIdSessionSessionIdRouteImport.update({
            id: '/summit/$summitId/session/$sessionId',path: '/summit/$summitId/session/$sessionId',getParentRoute: () => PublicRoute
          })
const PublicWheelOfLifeResultsIdPrintRoute = PublicWheelOfLifeResultsIdPrintRouteImport.update({
            id: '/results/$id_/print',path: '/results/$id/print',getParentRoute: () => PublicWheelOfLifeRoute
          })
const UserMyCoachingBusinessCoursesCourseSlugRoute = UserMyCoachingBusinessCoursesCourseSlugRouteImport.update({
            id: '/business/courses/$courseSlug',path: '/business/courses/$courseSlug',getParentRoute: () => UserMyCoachingRoute
          })
const UserMyCoachingBusinessLeadMagnetsIndexRoute = UserMyCoachingBusinessLeadMagnetsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingBusinessLeadMagnetsRoute
          })
const UserMyCoachingBusinessLeadMagnetsLeadsRoute = UserMyCoachingBusinessLeadMagnetsLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => UserMyCoachingBusinessLeadMagnetsRoute
          })
const UserMyCoachingBusinessNovaIndexRoute = UserMyCoachingBusinessNovaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingBusinessNovaRoute
          })
const UserMyCoachingBusinessNovaConversationIdRoute = UserMyCoachingBusinessNovaConversationIdRouteImport.update({
            id: '/$conversationId',path: '/$conversationId',getParentRoute: () => UserMyCoachingBusinessNovaRoute
          })
const UserMyCoachingBusinessNovaArchiveRoute = UserMyCoachingBusinessNovaArchiveRouteImport.update({
            id: '/archive',path: '/archive',getParentRoute: () => UserMyCoachingBusinessNovaRoute
          })
const UserMyCoachingBusinessNovaAssetsRoute = UserMyCoachingBusinessNovaAssetsRouteImport.update({
            id: '/assets',path: '/assets',getParentRoute: () => UserMyCoachingBusinessNovaRoute
          })
const UserMyCoachingBusinessNovaContentRoute = UserMyCoachingBusinessNovaContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => UserMyCoachingBusinessNovaRoute
          })
const UserMyCoachingBusinessNovaKnowsRoute = UserMyCoachingBusinessNovaKnowsRouteImport.update({
            id: '/knows',path: '/knows',getParentRoute: () => UserMyCoachingBusinessNovaRoute
          })
const UserMyCoachingBusinessNovaRoutinesRoute = UserMyCoachingBusinessNovaRoutinesRouteImport.update({
            id: '/routines',path: '/routines',getParentRoute: () => UserMyCoachingBusinessNovaRoute
          })
const UserMyCoachingClientsProgramsIndexRoute = UserMyCoachingClientsProgramsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingClientsProgramsRoute
          })
const UserMyCoachingClientsProgramsEngagementIdRoute = UserMyCoachingClientsProgramsEngagementIdRouteImport.update({
            id: '/$engagementId',path: '/$engagementId',getParentRoute: () => UserMyCoachingClientsProgramsRoute
          })
const UserMyCoachingClientsProgramsNewRoute = UserMyCoachingClientsProgramsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => UserMyCoachingClientsProgramsRoute
          })
const UserMyCoachingProfileOffersIndexRoute = UserMyCoachingProfileOffersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingProfileOffersRoute
          })
const UserMyCoachingProfileOffersOfferIdRoute = UserMyCoachingProfileOffersOfferIdRouteImport.update({
            id: '/$offerId',path: '/$offerId',getParentRoute: () => UserMyCoachingProfileOffersRoute
          })
const UserMyOrganizationSlugPagesIndexRoute = UserMyOrganizationSlugPagesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyOrganizationSlugPagesRoute
          })
const UserMyOrganizationSlugPagesProgramIdRoute = UserMyOrganizationSlugPagesProgramIdRouteImport.update({
            id: '/$programId',path: '/$programId',getParentRoute: () => UserMyOrganizationSlugPagesRoute
          })
const UserSettingsProfileBillingChangeRoute = UserSettingsProfileBillingChangeRouteImport.update({
            id: '/billing_/change',path: '/billing/change',getParentRoute: () => UserSettingsProfileRoute
          })
const AdminCoursesCourseIdWeeksWeekIdRoute = AdminCoursesCourseIdWeeksWeekIdRouteImport.update({
            id: '/weeks/$weekId',path: '/weeks/$weekId',getParentRoute: () => AdminCoursesCourseIdRoute
          })
const UserMyCoachingBusinessCoursesCourseSlugIndexRoute = UserMyCoachingBusinessCoursesCourseSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingBusinessCoursesCourseSlugRoute
          })
const UserMyCoachingBusinessLeadMagnetsLeadsIndexRoute = UserMyCoachingBusinessLeadMagnetsLeadsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingBusinessLeadMagnetsLeadsRoute
          })
const UserMyCoachingBusinessLeadMagnetsLeadsLeadIdRoute = UserMyCoachingBusinessLeadMagnetsLeadsLeadIdRouteImport.update({
            id: '/$leadId',path: '/$leadId',getParentRoute: () => UserMyCoachingBusinessLeadMagnetsLeadsRoute
          })
const UserMyCoachingBusinessNovaAssetsIndexRoute = UserMyCoachingBusinessNovaAssetsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingBusinessNovaAssetsRoute
          })
const UserMyCoachingBusinessNovaAssetsAssetKeyRoute = UserMyCoachingBusinessNovaAssetsAssetKeyRouteImport.update({
            id: '/$assetKey',path: '/$assetKey',getParentRoute: () => UserMyCoachingBusinessNovaAssetsRoute
          })
const UserMyCoachingBusinessNovaAssetsCheckInRoute = UserMyCoachingBusinessNovaAssetsCheckInRouteImport.update({
            id: '/check-in',path: '/check-in',getParentRoute: () => UserMyCoachingBusinessNovaAssetsRoute
          })
const UserMyCoachingClientsProgramsEngagementIdIndexRoute = UserMyCoachingClientsProgramsEngagementIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdAdminRoute = UserMyCoachingClientsProgramsEngagementIdAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdClientGoalsRoute = UserMyCoachingClientsProgramsEngagementIdClientGoalsRouteImport.update({
            id: '/client-goals',path: '/client-goals',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdClientVisionRoute = UserMyCoachingClientsProgramsEngagementIdClientVisionRouteImport.update({
            id: '/client-vision',path: '/client-vision',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdCoachingGoalsAndOutcomesRoute = UserMyCoachingClientsProgramsEngagementIdCoachingGoalsAndOutcomesRouteImport.update({
            id: '/coaching-goals-and-outcomes',path: '/coaching-goals-and-outcomes',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdCoachingResourcesRoute = UserMyCoachingClientsProgramsEngagementIdCoachingResourcesRouteImport.update({
            id: '/coaching-resources',path: '/coaching-resources',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdHomeworkRoute = UserMyCoachingClientsProgramsEngagementIdHomeworkRouteImport.update({
            id: '/homework',path: '/homework',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdMessagesRoute = UserMyCoachingClientsProgramsEngagementIdMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdNotesRoute = UserMyCoachingClientsProgramsEngagementIdNotesRouteImport.update({
            id: '/notes',path: '/notes',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdSessionsRoute = UserMyCoachingClientsProgramsEngagementIdSessionsRouteImport.update({
            id: '/sessions',path: '/sessions',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const PublicCoachesCitySlugCategoryCategorySlugIndexRoute = PublicCoachesCitySlugCategoryCategorySlugIndexRouteImport.update({
            id: '/coaches/city/$slug/category/$categorySlug/',path: '/coaches/city/$slug/category/$categorySlug/',getParentRoute: () => PublicRoute
          })
const PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute = PublicCoachesCitySlugSubcategorySubcategorySlugIndexRouteImport.update({
            id: '/coaches/city/$slug/subcategory/$subcategorySlug/',path: '/coaches/city/$slug/subcategory/$subcategorySlug/',getParentRoute: () => PublicRoute
          })
const UserMyCoachingBusinessCoursesCourseSlugWeeksWeekNumberRoute = UserMyCoachingBusinessCoursesCourseSlugWeeksWeekNumberRouteImport.update({
            id: '/weeks/$weekNumber',path: '/weeks/$weekNumber',getParentRoute: () => UserMyCoachingBusinessCoursesCourseSlugRoute
          })
const UserMyCoachingBusinessNovaAssetsAssetKeyIndexRoute = UserMyCoachingBusinessNovaAssetsAssetKeyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UserMyCoachingBusinessNovaAssetsAssetKeyRoute
          })
const UserMyCoachingBusinessNovaAssetsAssetKeyItemIdRoute = UserMyCoachingBusinessNovaAssetsAssetKeyItemIdRouteImport.update({
            id: '/$itemId',path: '/$itemId',getParentRoute: () => UserMyCoachingBusinessNovaAssetsAssetKeyRoute
          })
const UserMyCoachingClientsProgramsEngagementIdVisionCategoryIdRoute = UserMyCoachingClientsProgramsEngagementIdVisionCategoryIdRouteImport.update({
            id: '/vision/$categoryId',path: '/vision/$categoryId',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })
const UserMyCoachingClientsProgramsEngagementIdWheelShareIdRoute = UserMyCoachingClientsProgramsEngagementIdWheelShareIdRouteImport.update({
            id: '/wheel/$shareId',path: '/wheel/$shareId',getParentRoute: () => UserMyCoachingClientsProgramsEngagementIdRoute
          })





const UsernameProfileResourcesRouteChildren = {
  UsernameProfileResourcesIndexRoute: UsernameProfileResourcesIndexRoute,UsernameProfileResourcesResourceIdIndexRoute: UsernameProfileResourcesResourceIdIndexRoute
}

const UsernameProfileResourcesRouteWithChildren = UsernameProfileResourcesRoute._addFileChildren(UsernameProfileResourcesRouteChildren)



const UsernameProfileRouteChildren = {
  UsernameProfileResourcesRoute: UsernameProfileResourcesRouteWithChildren,UsernameProfileIndexRoute: UsernameProfileIndexRoute
}

const UsernameProfileRouteWithChildren = UsernameProfileRoute._addFileChildren(UsernameProfileRouteChildren)




const UsernameOfferRouteChildren = {
  UsernameOfferIndexRoute: UsernameOfferIndexRoute,UsernameOfferOfferIdIndexRoute: UsernameOfferOfferIdIndexRoute
}

const UsernameOfferRouteWithChildren = UsernameOfferRoute._addFileChildren(UsernameOfferRouteChildren)



const UsernameRouteChildren = {
  UsernameProfileRoute: UsernameProfileRouteWithChildren,UsernameOfferRoute: UsernameOfferRouteWithChildren,UsernameBookIndexRoute: UsernameBookIndexRoute,UsernameContactIndexRoute: UsernameContactIndexRoute,UsernameWheelOfLifeIndexRoute: UsernameWheelOfLifeIndexRoute,UsernameWheelOfLifeResultsIdRoute: UsernameWheelOfLifeResultsIdRoute,UsernameWheelOfLifeResultsIdPrintRoute: UsernameWheelOfLifeResultsIdPrintRoute
}

const UsernameRouteWithChildren = UsernameRoute._addFileChildren(UsernameRouteChildren)




const AuthRouteChildren = {
  AuthAcceptTokenIndexRoute: AuthAcceptTokenIndexRoute,AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,AuthLoginIndexRoute: AuthLoginIndexRoute,AuthSigninIndexRoute: AuthSigninIndexRoute,AuthSignupIndexRoute: AuthSignupIndexRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const PublicAboutRouteChildren = {
  PublicAboutAdvisoryCouncilRoute: PublicAboutAdvisoryCouncilRoute,PublicAboutIndexRoute: PublicAboutIndexRoute
}

const PublicAboutRouteWithChildren = PublicAboutRoute._addFileChildren(PublicAboutRouteChildren)




const PublicArticlesRouteChildren = {
  PublicArticlesSlugRoute: PublicArticlesSlugRoute,PublicArticlesIndexRoute: PublicArticlesIndexRoute
}

const PublicArticlesRouteWithChildren = PublicArticlesRoute._addFileChildren(PublicArticlesRouteChildren)




const PublicBrandRouteChildren = {
  PublicBrandComponentsIndexRoute: PublicBrandComponentsIndexRoute,PublicBrandGuidelineIndexRoute: PublicBrandGuidelineIndexRoute
}

const PublicBrandRouteWithChildren = PublicBrandRoute._addFileChildren(PublicBrandRouteChildren)




const PublicCoachingBusinessPlaybooksRouteChildren = {
  PublicCoachingBusinessPlaybooksSlugRoute: PublicCoachingBusinessPlaybooksSlugRoute,PublicCoachingBusinessPlaybooksIndexRoute: PublicCoachingBusinessPlaybooksIndexRoute
}

const PublicCoachingBusinessPlaybooksRouteWithChildren = PublicCoachingBusinessPlaybooksRoute._addFileChildren(PublicCoachingBusinessPlaybooksRouteChildren)



const PublicCoachingBusinessRouteChildren = {
  PublicCoachingBusinessGuideSlugRoute: PublicCoachingBusinessGuideSlugRoute,PublicCoachingBusinessPlaybooksRoute: PublicCoachingBusinessPlaybooksRouteWithChildren,PublicCoachingBusinessIndexRoute: PublicCoachingBusinessIndexRoute
}

const PublicCoachingBusinessRouteWithChildren = PublicCoachingBusinessRoute._addFileChildren(PublicCoachingBusinessRouteChildren)




const PublicOrganizationsSlugRouteChildren = {
  PublicOrganizationsSlugClaimRoute: PublicOrganizationsSlugClaimRoute,PublicOrganizationsSlugCoachesRoute: PublicOrganizationsSlugCoachesRoute,PublicOrganizationsSlugJoinRoute: PublicOrganizationsSlugJoinRoute,PublicOrganizationsSlugTrainingProgramsRoute: PublicOrganizationsSlugTrainingProgramsRoute,PublicOrganizationsSlugIndexRoute: PublicOrganizationsSlugIndexRoute
}

const PublicOrganizationsSlugRouteWithChildren = PublicOrganizationsSlugRoute._addFileChildren(PublicOrganizationsSlugRouteChildren)



const PublicOrganizationsRouteChildren = {
  PublicOrganizationsSlugRoute: PublicOrganizationsSlugRouteWithChildren,PublicOrganizationsIndexRoute: PublicOrganizationsIndexRoute
}

const PublicOrganizationsRouteWithChildren = PublicOrganizationsRoute._addFileChildren(PublicOrganizationsRouteChildren)




const PublicTrainingProgramsSlugRouteChildren = {
  PublicTrainingProgramsSlugCoachesRoute: PublicTrainingProgramsSlugCoachesRoute,PublicTrainingProgramsSlugIndexRoute: PublicTrainingProgramsSlugIndexRoute
}

const PublicTrainingProgramsSlugRouteWithChildren = PublicTrainingProgramsSlugRoute._addFileChildren(PublicTrainingProgramsSlugRouteChildren)



const PublicTrainingProgramsRouteChildren = {
  PublicTrainingProgramsSlugRoute: PublicTrainingProgramsSlugRouteWithChildren,PublicTrainingProgramsIndexRoute: PublicTrainingProgramsIndexRoute
}

const PublicTrainingProgramsRouteWithChildren = PublicTrainingProgramsRoute._addFileChildren(PublicTrainingProgramsRouteChildren)




const PublicWheelOfLifeRouteChildren = {
  PublicWheelOfLifeTemplateRoute: PublicWheelOfLifeTemplateRoute,PublicWheelOfLifeIndexRoute: PublicWheelOfLifeIndexRoute,PublicWheelOfLifeResultsIdRoute: PublicWheelOfLifeResultsIdRoute,PublicWheelOfLifeResultsIdPrintRoute: PublicWheelOfLifeResultsIdPrintRoute
}

const PublicWheelOfLifeRouteWithChildren = PublicWheelOfLifeRoute._addFileChildren(PublicWheelOfLifeRouteChildren)




const PublicCoachingForChallengeSlugRouteChildren = {
  PublicCoachingForChallengeSlugArticlesRoute: PublicCoachingForChallengeSlugArticlesRoute,PublicCoachingForChallengeSlugCoachesRoute: PublicCoachingForChallengeSlugCoachesRoute,PublicCoachingForChallengeSlugIndexRoute: PublicCoachingForChallengeSlugIndexRoute
}

const PublicCoachingForChallengeSlugRouteWithChildren = PublicCoachingForChallengeSlugRoute._addFileChildren(PublicCoachingForChallengeSlugRouteChildren)




const PublicDiscoveryUsernameRouteChildren = {
  PublicDiscoveryUsernameIndexRoute: PublicDiscoveryUsernameIndexRoute,PublicDiscoveryUsernameBookIndexRoute: PublicDiscoveryUsernameBookIndexRoute,PublicDiscoveryUsernameOfferIndexRoute: PublicDiscoveryUsernameOfferIndexRoute,PublicDiscoveryUsernameResourcesIndexRoute: PublicDiscoveryUsernameResourcesIndexRoute
}

const PublicDiscoveryUsernameRouteWithChildren = PublicDiscoveryUsernameRoute._addFileChildren(PublicDiscoveryUsernameRouteChildren)




const PublicDiscoveryMatchRouteChildren = {
  PublicDiscoveryMatchContextRoute: PublicDiscoveryMatchContextRoute,PublicDiscoveryMatchIndexRoute: PublicDiscoveryMatchIndexRoute
}

const PublicDiscoveryMatchRouteWithChildren = PublicDiscoveryMatchRoute._addFileChildren(PublicDiscoveryMatchRouteChildren)




const PublicDiscoveryRefineRouteChildren = {
  PublicDiscoveryRefineFitRoute: PublicDiscoveryRefineFitRoute,PublicDiscoveryRefineLogisticsRoute: PublicDiscoveryRefineLogisticsRoute,PublicDiscoveryRefineIndexRoute: PublicDiscoveryRefineIndexRoute
}

const PublicDiscoveryRefineRouteWithChildren = PublicDiscoveryRefineRoute._addFileChildren(PublicDiscoveryRefineRouteChildren)




const PublicDiscoveryStepsRouteChildren = {
  PublicDiscoveryStepsIndexRoute: PublicDiscoveryStepsIndexRoute,PublicDiscoverySteps1IndexRoute: PublicDiscoverySteps1IndexRoute,PublicDiscoverySteps10IndexRoute: PublicDiscoverySteps10IndexRoute,PublicDiscoverySteps2IndexRoute: PublicDiscoverySteps2IndexRoute,PublicDiscoverySteps3IndexRoute: PublicDiscoverySteps3IndexRoute,PublicDiscoverySteps4IndexRoute: PublicDiscoverySteps4IndexRoute,PublicDiscoverySteps5IndexRoute: PublicDiscoverySteps5IndexRoute,PublicDiscoverySteps6IndexRoute: PublicDiscoverySteps6IndexRoute,PublicDiscoverySteps7IndexRoute: PublicDiscoverySteps7IndexRoute,PublicDiscoverySteps8IndexRoute: PublicDiscoverySteps8IndexRoute,PublicDiscoverySteps9IndexRoute: PublicDiscoverySteps9IndexRoute,PublicDiscoveryStepsProcessingIndexRoute: PublicDiscoveryStepsProcessingIndexRoute
}

const PublicDiscoveryStepsRouteWithChildren = PublicDiscoveryStepsRoute._addFileChildren(PublicDiscoveryStepsRouteChildren)




const PublicFrameworksSlugRouteChildren = {
  PublicFrameworksSlugCoachesRoute: PublicFrameworksSlugCoachesRoute,PublicFrameworksSlugTrainingProgramsRoute: PublicFrameworksSlugTrainingProgramsRoute,PublicFrameworksSlugIndexRoute: PublicFrameworksSlugIndexRoute
}

const PublicFrameworksSlugRouteWithChildren = PublicFrameworksSlugRoute._addFileChildren(PublicFrameworksSlugRouteChildren)



const PublicRouteChildren = {
  Public6FigureReadinessScoreRoute: Public6FigureReadinessScoreRoute,PublicAboutRoute: PublicAboutRouteWithChildren,PublicArticlesRoute: PublicArticlesRouteWithChildren,PublicBrandRoute: PublicBrandRouteWithChildren,PublicCoachBusinessBuilderRoute: PublicCoachBusinessBuilderRoute,PublicCoachingBusinessRoute: PublicCoachingBusinessRouteWithChildren,PublicCoachingIntelligenceRoute: PublicCoachingIntelligenceRoute,PublicDcmVsBetterupRoute: PublicDcmVsBetterupRoute,PublicHowItWorksRoute: PublicHowItWorksRoute,PublicOrganizationsRoute: PublicOrganizationsRouteWithChildren,PublicOurCoachesRoute: PublicOurCoachesRoute,PublicPrivacyRoute: PublicPrivacyRoute,PublicPrivacyPolicyRoute: PublicPrivacyPolicyRoute,PublicTrainingProgramsRoute: PublicTrainingProgramsRouteWithChildren,PublicVisionRoute: PublicVisionRoute,PublicWhatWeOfferRoute: PublicWhatWeOfferRoute,PublicWheelRoute: PublicWheelRoute,PublicWheelOfLifeRoute: PublicWheelOfLifeRouteWithChildren,PublicCoachingForChallengeSlugRoute: PublicCoachingForChallengeSlugRouteWithChildren,PublicDiscoveryUsernameRoute: PublicDiscoveryUsernameRouteWithChildren,PublicDiscoveryMatchRoute: PublicDiscoveryMatchRouteWithChildren,PublicDiscoveryRefineRoute: PublicDiscoveryRefineRouteWithChildren,PublicDiscoveryResultsRoute: PublicDiscoveryResultsRoute,PublicDiscoveryStepsRoute: PublicDiscoveryStepsRouteWithChildren,PublicFrameworksSlugRoute: PublicFrameworksSlugRouteWithChildren,PublicGoalsShareSlugRoute: PublicGoalsShareSlugRoute,PublicOrganizationInviteTokenRoute: PublicOrganizationInviteTokenRoute,PublicSummitDebugRoute: PublicSummitDebugRoute,PublicWIdRoute: PublicWIdRoute,PublicCcosIndexRoute: PublicCcosIndexRoute,PublicCoachesIndexRoute: PublicCoachesIndexRoute,PublicCoachingForIndexRoute: PublicCoachingForIndexRoute,PublicDiscoveryIndexRoute: PublicDiscoveryIndexRoute,PublicFrameworksIndexRoute: PublicFrameworksIndexRoute,PublicStoriesIndexRoute: PublicStoriesIndexRoute,PublicCoachesCtpSlugRoute: PublicCoachesCtpSlugRoute,PublicSummitSummitIdRecapRoute: PublicSummitSummitIdRecapRoute,PublicCoachesCategoryIndexRoute: PublicCoachesCategoryIndexRoute,PublicCoachesCcoIndexRoute: PublicCoachesCcoIndexRoute,PublicCoachesCityIndexRoute: PublicCoachesCityIndexRoute,PublicCoachesCtpIndexRoute: PublicCoachesCtpIndexRoute,PublicCoachesFoundingIndexRoute: PublicCoachesFoundingIndexRoute,PublicCoachesSubcategoryIndexRoute: PublicCoachesSubcategoryIndexRoute,PublicPageNameIndexRoute: PublicPageNameIndexRoute,PublicSummitSummitIdSessionSessionIdRoute: PublicSummitSummitIdSessionSessionIdRoute,PublicCoachesCategoryCategorySlugIndexRoute: PublicCoachesCategoryCategorySlugIndexRoute,PublicCoachesCcoSlugIndexRoute: PublicCoachesCcoSlugIndexRoute,PublicCoachesCitySlugIndexRoute: PublicCoachesCitySlugIndexRoute,PublicCoachesSubcategorySubcategorySlugIndexRoute: PublicCoachesSubcategorySubcategorySlugIndexRoute,PublicCoachesCitySlugCategoryCategorySlugIndexRoute: PublicCoachesCitySlugCategoryCategorySlugIndexRoute,PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute: PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)




const UserCoachingEngagementIdRouteChildren = {
  UserCoachingEngagementIdAdminRoute: UserCoachingEngagementIdAdminRoute,UserCoachingEngagementIdCoachingGoalsAndOutcomesRoute: UserCoachingEngagementIdCoachingGoalsAndOutcomesRoute,UserCoachingEngagementIdCoachingResourcesRoute: UserCoachingEngagementIdCoachingResourcesRoute,UserCoachingEngagementIdHomeworkRoute: UserCoachingEngagementIdHomeworkRoute,UserCoachingEngagementIdMessagesRoute: UserCoachingEngagementIdMessagesRoute,UserCoachingEngagementIdNotesRoute: UserCoachingEngagementIdNotesRoute,UserCoachingEngagementIdSessionsRoute: UserCoachingEngagementIdSessionsRoute,UserCoachingEngagementIdIndexRoute: UserCoachingEngagementIdIndexRoute
}

const UserCoachingEngagementIdRouteWithChildren = UserCoachingEngagementIdRoute._addFileChildren(UserCoachingEngagementIdRouteChildren)



const UserCoachingRouteChildren = {
  UserCoachingEngagementIdRoute: UserCoachingEngagementIdRouteWithChildren,UserCoachingIndexRoute: UserCoachingIndexRoute,UserCoachingEngagementIdWelcomeRoute: UserCoachingEngagementIdWelcomeRoute
}

const UserCoachingRouteWithChildren = UserCoachingRoute._addFileChildren(UserCoachingRouteChildren)




const UserContactsRouteChildren = {
  UserContactsIndexRoute: UserContactsIndexRoute
}

const UserContactsRouteWithChildren = UserContactsRoute._addFileChildren(UserContactsRouteChildren)




const UserLifeDesignRouteChildren = {
  UserLifeDesignCategoryIdRoute: UserLifeDesignCategoryIdRoute,UserLifeDesignGoalsRoute: UserLifeDesignGoalsRoute,UserLifeDesignNewCategoryRoute: UserLifeDesignNewCategoryRoute,UserLifeDesignOverallVisionRoute: UserLifeDesignOverallVisionRoute,UserLifeDesignIndexRoute: UserLifeDesignIndexRoute
}

const UserLifeDesignRouteWithChildren = UserLifeDesignRoute._addFileChildren(UserLifeDesignRouteChildren)




const UserMessagesRouteChildren = {
  UserMessagesIndexRoute: UserMessagesIndexRoute,UserMessagesConversationIdIndexRoute: UserMessagesConversationIdIndexRoute
}

const UserMessagesRouteWithChildren = UserMessagesRoute._addFileChildren(UserMessagesRouteChildren)




const UserMyCoachingArticlesRouteChildren = {
  UserMyCoachingArticlesArticleIdRoute: UserMyCoachingArticlesArticleIdRoute,UserMyCoachingArticlesNewRoute: UserMyCoachingArticlesNewRoute,UserMyCoachingArticlesIndexRoute: UserMyCoachingArticlesIndexRoute
}

const UserMyCoachingArticlesRouteWithChildren = UserMyCoachingArticlesRoute._addFileChildren(UserMyCoachingArticlesRouteChildren)




const UserMyCoachingProfileOffersRouteChildren = {
  UserMyCoachingProfileOffersOfferIdRoute: UserMyCoachingProfileOffersOfferIdRoute,UserMyCoachingProfileOffersIndexRoute: UserMyCoachingProfileOffersIndexRoute
}

const UserMyCoachingProfileOffersRouteWithChildren = UserMyCoachingProfileOffersRoute._addFileChildren(UserMyCoachingProfileOffersRouteChildren)



const UserMyCoachingProfileRouteChildren = {
  UserMyCoachingProfileBioRoute: UserMyCoachingProfileBioRoute,UserMyCoachingProfileDetailsRoute: UserMyCoachingProfileDetailsRoute,UserMyCoachingProfileOffersRoute: UserMyCoachingProfileOffersRouteWithChildren,UserMyCoachingProfilePersonalInfoRoute: UserMyCoachingProfilePersonalInfoRoute,UserMyCoachingProfileQualificationsRoute: UserMyCoachingProfileQualificationsRoute,UserMyCoachingProfileTestimonialsRoute: UserMyCoachingProfileTestimonialsRoute
}

const UserMyCoachingProfileRouteWithChildren = UserMyCoachingProfileRoute._addFileChildren(UserMyCoachingProfileRouteChildren)




const UserMyCoachingBusinessLeadMagnetsLeadsRouteChildren = {
  UserMyCoachingBusinessLeadMagnetsLeadsLeadIdRoute: UserMyCoachingBusinessLeadMagnetsLeadsLeadIdRoute,UserMyCoachingBusinessLeadMagnetsLeadsIndexRoute: UserMyCoachingBusinessLeadMagnetsLeadsIndexRoute
}

const UserMyCoachingBusinessLeadMagnetsLeadsRouteWithChildren = UserMyCoachingBusinessLeadMagnetsLeadsRoute._addFileChildren(UserMyCoachingBusinessLeadMagnetsLeadsRouteChildren)



const UserMyCoachingBusinessLeadMagnetsRouteChildren = {
  UserMyCoachingBusinessLeadMagnetsLeadsRoute: UserMyCoachingBusinessLeadMagnetsLeadsRouteWithChildren,UserMyCoachingBusinessLeadMagnetsIndexRoute: UserMyCoachingBusinessLeadMagnetsIndexRoute
}

const UserMyCoachingBusinessLeadMagnetsRouteWithChildren = UserMyCoachingBusinessLeadMagnetsRoute._addFileChildren(UserMyCoachingBusinessLeadMagnetsRouteChildren)




const UserMyCoachingBusinessNovaAssetsAssetKeyRouteChildren = {
  UserMyCoachingBusinessNovaAssetsAssetKeyItemIdRoute: UserMyCoachingBusinessNovaAssetsAssetKeyItemIdRoute,UserMyCoachingBusinessNovaAssetsAssetKeyIndexRoute: UserMyCoachingBusinessNovaAssetsAssetKeyIndexRoute
}

const UserMyCoachingBusinessNovaAssetsAssetKeyRouteWithChildren = UserMyCoachingBusinessNovaAssetsAssetKeyRoute._addFileChildren(UserMyCoachingBusinessNovaAssetsAssetKeyRouteChildren)



const UserMyCoachingBusinessNovaAssetsRouteChildren = {
  UserMyCoachingBusinessNovaAssetsAssetKeyRoute: UserMyCoachingBusinessNovaAssetsAssetKeyRouteWithChildren,UserMyCoachingBusinessNovaAssetsCheckInRoute: UserMyCoachingBusinessNovaAssetsCheckInRoute,UserMyCoachingBusinessNovaAssetsIndexRoute: UserMyCoachingBusinessNovaAssetsIndexRoute
}

const UserMyCoachingBusinessNovaAssetsRouteWithChildren = UserMyCoachingBusinessNovaAssetsRoute._addFileChildren(UserMyCoachingBusinessNovaAssetsRouteChildren)



const UserMyCoachingBusinessNovaRouteChildren = {
  UserMyCoachingBusinessNovaConversationIdRoute: UserMyCoachingBusinessNovaConversationIdRoute,UserMyCoachingBusinessNovaArchiveRoute: UserMyCoachingBusinessNovaArchiveRoute,UserMyCoachingBusinessNovaAssetsRoute: UserMyCoachingBusinessNovaAssetsRouteWithChildren,UserMyCoachingBusinessNovaContentRoute: UserMyCoachingBusinessNovaContentRoute,UserMyCoachingBusinessNovaKnowsRoute: UserMyCoachingBusinessNovaKnowsRoute,UserMyCoachingBusinessNovaRoutinesRoute: UserMyCoachingBusinessNovaRoutinesRoute,UserMyCoachingBusinessNovaIndexRoute: UserMyCoachingBusinessNovaIndexRoute
}

const UserMyCoachingBusinessNovaRouteWithChildren = UserMyCoachingBusinessNovaRoute._addFileChildren(UserMyCoachingBusinessNovaRouteChildren)




const UserMyCoachingClientsProgramsEngagementIdRouteChildren = {
  UserMyCoachingClientsProgramsEngagementIdAdminRoute: UserMyCoachingClientsProgramsEngagementIdAdminRoute,UserMyCoachingClientsProgramsEngagementIdClientGoalsRoute: UserMyCoachingClientsProgramsEngagementIdClientGoalsRoute,UserMyCoachingClientsProgramsEngagementIdClientVisionRoute: UserMyCoachingClientsProgramsEngagementIdClientVisionRoute,UserMyCoachingClientsProgramsEngagementIdCoachingGoalsAndOutcomesRoute: UserMyCoachingClientsProgramsEngagementIdCoachingGoalsAndOutcomesRoute,UserMyCoachingClientsProgramsEngagementIdCoachingResourcesRoute: UserMyCoachingClientsProgramsEngagementIdCoachingResourcesRoute,UserMyCoachingClientsProgramsEngagementIdHomeworkRoute: UserMyCoachingClientsProgramsEngagementIdHomeworkRoute,UserMyCoachingClientsProgramsEngagementIdMessagesRoute: UserMyCoachingClientsProgramsEngagementIdMessagesRoute,UserMyCoachingClientsProgramsEngagementIdNotesRoute: UserMyCoachingClientsProgramsEngagementIdNotesRoute,UserMyCoachingClientsProgramsEngagementIdSessionsRoute: UserMyCoachingClientsProgramsEngagementIdSessionsRoute,UserMyCoachingClientsProgramsEngagementIdIndexRoute: UserMyCoachingClientsProgramsEngagementIdIndexRoute,UserMyCoachingClientsProgramsEngagementIdVisionCategoryIdRoute: UserMyCoachingClientsProgramsEngagementIdVisionCategoryIdRoute,UserMyCoachingClientsProgramsEngagementIdWheelShareIdRoute: UserMyCoachingClientsProgramsEngagementIdWheelShareIdRoute
}

const UserMyCoachingClientsProgramsEngagementIdRouteWithChildren = UserMyCoachingClientsProgramsEngagementIdRoute._addFileChildren(UserMyCoachingClientsProgramsEngagementIdRouteChildren)



const UserMyCoachingClientsProgramsRouteChildren = {
  UserMyCoachingClientsProgramsEngagementIdRoute: UserMyCoachingClientsProgramsEngagementIdRouteWithChildren,UserMyCoachingClientsProgramsNewRoute: UserMyCoachingClientsProgramsNewRoute,UserMyCoachingClientsProgramsIndexRoute: UserMyCoachingClientsProgramsIndexRoute
}

const UserMyCoachingClientsProgramsRouteWithChildren = UserMyCoachingClientsProgramsRoute._addFileChildren(UserMyCoachingClientsProgramsRouteChildren)




const UserMyCoachingBusinessCoursesCourseSlugRouteChildren = {
  UserMyCoachingBusinessCoursesCourseSlugIndexRoute: UserMyCoachingBusinessCoursesCourseSlugIndexRoute,UserMyCoachingBusinessCoursesCourseSlugWeeksWeekNumberRoute: UserMyCoachingBusinessCoursesCourseSlugWeeksWeekNumberRoute
}

const UserMyCoachingBusinessCoursesCourseSlugRouteWithChildren = UserMyCoachingBusinessCoursesCourseSlugRoute._addFileChildren(UserMyCoachingBusinessCoursesCourseSlugRouteChildren)



const UserMyCoachingRouteChildren = {
  UserMyCoachingAcceleratorRoute: UserMyCoachingAcceleratorRoute,UserMyCoachingArticlesRoute: UserMyCoachingArticlesRouteWithChildren,UserMyCoachingProfileRoute: UserMyCoachingProfileRouteWithChildren,UserMyCoachingReferralsRoute: UserMyCoachingReferralsRoute,UserMyCoachingStripeConnectRoute: UserMyCoachingStripeConnectRoute,UserMyCoachingWelcomeRoute: UserMyCoachingWelcomeRoute,UserMyCoachingWhatsComingRoute: UserMyCoachingWhatsComingRoute,UserMyCoachingWhatsNewRoute: UserMyCoachingWhatsNewRoute,UserMyCoachingIndexRoute: UserMyCoachingIndexRoute,UserMyCoachingBusinessLeadMagnetsRoute: UserMyCoachingBusinessLeadMagnetsRouteWithChildren,UserMyCoachingBusinessMarketingSuiteRoute: UserMyCoachingBusinessMarketingSuiteRoute,UserMyCoachingBusinessNovaRoute: UserMyCoachingBusinessNovaRouteWithChildren,UserMyCoachingBusinessReadinessScoreRoute: UserMyCoachingBusinessReadinessScoreRoute,UserMyCoachingBusinessReadingRoute: UserMyCoachingBusinessReadingRoute,UserMyCoachingClientsDashboardRoute: UserMyCoachingClientsDashboardRoute,UserMyCoachingClientsInvoicesRoute: UserMyCoachingClientsInvoicesRoute,UserMyCoachingClientsProgramsRoute: UserMyCoachingClientsProgramsRouteWithChildren,UserMyCoachingBusinessCoursesCourseSlugRoute: UserMyCoachingBusinessCoursesCourseSlugRouteWithChildren
}

const UserMyCoachingRouteWithChildren = UserMyCoachingRoute._addFileChildren(UserMyCoachingRouteChildren)




const UserMyOrganizationSlugPagesRouteChildren = {
  UserMyOrganizationSlugPagesProgramIdRoute: UserMyOrganizationSlugPagesProgramIdRoute,UserMyOrganizationSlugPagesIndexRoute: UserMyOrganizationSlugPagesIndexRoute
}

const UserMyOrganizationSlugPagesRouteWithChildren = UserMyOrganizationSlugPagesRoute._addFileChildren(UserMyOrganizationSlugPagesRouteChildren)



const UserMyOrganizationSlugRouteChildren = {
  UserMyOrganizationSlugClaimsRoute: UserMyOrganizationSlugClaimsRoute,UserMyOrganizationSlugGraduatesRoute: UserMyOrganizationSlugGraduatesRoute,UserMyOrganizationSlugInviteRoute: UserMyOrganizationSlugInviteRoute,UserMyOrganizationSlugPagesRoute: UserMyOrganizationSlugPagesRouteWithChildren,UserMyOrganizationSlugIndexRoute: UserMyOrganizationSlugIndexRoute
}

const UserMyOrganizationSlugRouteWithChildren = UserMyOrganizationSlugRoute._addFileChildren(UserMyOrganizationSlugRouteChildren)



const UserMyOrganizationRouteChildren = {
  UserMyOrganizationSlugRoute: UserMyOrganizationSlugRouteWithChildren,UserMyOrganizationIndexRoute: UserMyOrganizationIndexRoute
}

const UserMyOrganizationRouteWithChildren = UserMyOrganizationRoute._addFileChildren(UserMyOrganizationRouteChildren)




const UserSettingsProfileRouteChildren = {
  UserSettingsProfileBillingRoute: UserSettingsProfileBillingRoute,UserSettingsProfileCoachingPreferencesRoute: UserSettingsProfileCoachingPreferencesRoute,UserSettingsProfilePasswordSettingsRoute: UserSettingsProfilePasswordSettingsRoute,UserSettingsProfileIndexRoute: UserSettingsProfileIndexRoute,UserSettingsProfileBillingChangeRoute: UserSettingsProfileBillingChangeRoute
}

const UserSettingsProfileRouteWithChildren = UserSettingsProfileRoute._addFileChildren(UserSettingsProfileRouteChildren)



const UserSettingsRouteChildren = {
  UserSettingsProfileRoute: UserSettingsProfileRouteWithChildren,UserSettingsIndexRoute: UserSettingsIndexRoute,UserSettingsAccountIndexRoute: UserSettingsAccountIndexRoute,UserSettingsCalendarIndexRoute: UserSettingsCalendarIndexRoute,UserSettingsPasswordIndexRoute: UserSettingsPasswordIndexRoute
}

const UserSettingsRouteWithChildren = UserSettingsRoute._addFileChildren(UserSettingsRouteChildren)




const UserSummitsRouteChildren = {
  UserSummitsIndexRoute: UserSummitsIndexRoute
}

const UserSummitsRouteWithChildren = UserSummitsRoute._addFileChildren(UserSummitsRouteChildren)



const UserRouteChildren = {
  UserBecomeACoachRoute: UserBecomeACoachRoute,UserCoachingRoute: UserCoachingRouteWithChildren,UserContactsRoute: UserContactsRouteWithChildren,UserHelpRoute: UserHelpRoute,UserLifeDesignRoute: UserLifeDesignRouteWithChildren,UserMessagesRoute: UserMessagesRouteWithChildren,UserMyCoachingRoute: UserMyCoachingRouteWithChildren,UserMyOrganizationRoute: UserMyOrganizationRouteWithChildren,UserProPlusRoute: UserProPlusRoute,UserReferralsRoute: UserReferralsRoute,UserSettingsRoute: UserSettingsRouteWithChildren,UserSummitsRoute: UserSummitsRouteWithChildren,UserWelcomeRoute: UserWelcomeRoute,UserCoachDiscoveryIndexRoute: UserCoachDiscoveryIndexRoute,UserCoachFinderIndexRoute: UserCoachFinderIndexRoute,UserDashboardIndexRoute: UserDashboardIndexRoute
}

const UserRouteWithChildren = UserRoute._addFileChildren(UserRouteChildren)




const AdminCihStoriesRouteChildren = {
  AdminCihStoriesStoryIdRoute: AdminCihStoriesStoryIdRoute,AdminCihStoriesIndexRoute: AdminCihStoriesIndexRoute
}

const AdminCihStoriesRouteWithChildren = AdminCihStoriesRoute._addFileChildren(AdminCihStoriesRouteChildren)



const AdminCihRouteChildren = {
  AdminCihPageChangesRoute: AdminCihPageChangesRoute,AdminCihStoriesRoute: AdminCihStoriesRouteWithChildren,AdminCihIndexRoute: AdminCihIndexRoute,AdminCihArticlesArticleIdRoute: AdminCihArticlesArticleIdRoute,AdminCihArticlesNewRoute: AdminCihArticlesNewRoute,AdminCihCcosCcoIdRoute: AdminCihCcosCcoIdRoute,AdminCihChallengesChallengeIdRoute: AdminCihChallengesChallengeIdRoute,AdminCihCtpsCtpIdRoute: AdminCihCtpsCtpIdRoute,AdminCihFrameworksFrameworkIdRoute: AdminCihFrameworksFrameworkIdRoute,AdminCihGuidesGuideIdRoute: AdminCihGuidesGuideIdRoute,AdminCihPlaybooksPlaybookIdRoute: AdminCihPlaybooksPlaybookIdRoute,AdminCihThoughtLeadersThoughtLeaderIdRoute: AdminCihThoughtLeadersThoughtLeaderIdRoute,AdminCihArticlesIndexRoute: AdminCihArticlesIndexRoute,AdminCihCcosIndexRoute: AdminCihCcosIndexRoute,AdminCihChallengesIndexRoute: AdminCihChallengesIndexRoute,AdminCihCtpsIndexRoute: AdminCihCtpsIndexRoute,AdminCihFrameworksIndexRoute: AdminCihFrameworksIndexRoute,AdminCihGuidesIndexRoute: AdminCihGuidesIndexRoute,AdminCihPlaybooksIndexRoute: AdminCihPlaybooksIndexRoute,AdminCihThoughtLeadersIndexRoute: AdminCihThoughtLeadersIndexRoute
}

const AdminCihRouteWithChildren = AdminCihRoute._addFileChildren(AdminCihRouteChildren)




const AdminCoursesCourseIdRouteChildren = {
  AdminCoursesCourseIdIndexRoute: AdminCoursesCourseIdIndexRoute,AdminCoursesCourseIdWeeksWeekIdRoute: AdminCoursesCourseIdWeeksWeekIdRoute
}

const AdminCoursesCourseIdRouteWithChildren = AdminCoursesCourseIdRoute._addFileChildren(AdminCoursesCourseIdRouteChildren)



const AdminCoursesRouteChildren = {
  AdminCoursesCourseIdRoute: AdminCoursesCourseIdRouteWithChildren,AdminCoursesIndexRoute: AdminCoursesIndexRoute
}

const AdminCoursesRouteWithChildren = AdminCoursesRoute._addFileChildren(AdminCoursesRouteChildren)




const AdminVideosRouteChildren = {
  AdminVideosPlacementsRoute: AdminVideosPlacementsRoute,AdminVideosIndexRoute: AdminVideosIndexRoute
}

const AdminVideosRouteWithChildren = AdminVideosRoute._addFileChildren(AdminVideosRouteChildren)



const AdminRouteChildren = {
  AdminCihRoute: AdminCihRouteWithChildren,AdminCoursesRoute: AdminCoursesRouteWithChildren,AdminTransformationStoriesRoute: AdminTransformationStoriesRoute,AdminVideosRoute: AdminVideosRouteWithChildren,AdminIndexRoute: AdminIndexRoute,AdminSummitSessionsSessionIdRoute: AdminSummitSessionsSessionIdRoute,AdminCallsAndLinksIndexRoute: AdminCallsAndLinksIndexRoute,AdminCoachesIndexRoute: AdminCoachesIndexRoute,AdminCtpsIndexRoute: AdminCtpsIndexRoute,AdminFeatureFlagsIndexRoute: AdminFeatureFlagsIndexRoute,AdminFeatureVotesIndexRoute: AdminFeatureVotesIndexRoute,AdminFeeExemptionsIndexRoute: AdminFeeExemptionsIndexRoute,AdminFunnelHealthIndexRoute: AdminFunnelHealthIndexRoute,AdminIntegrationsIndexRoute: AdminIntegrationsIndexRoute,AdminMpaiIndexRoute: AdminMpaiIndexRoute,AdminNovaUsageIndexRoute: AdminNovaUsageIndexRoute,AdminReferralRewardsIndexRoute: AdminReferralRewardsIndexRoute,AdminSummitCtaIndexRoute: AdminSummitCtaIndexRoute,AdminSummitSessionsIndexRoute: AdminSummitSessionsIndexRoute,AdminUsersIndexRoute: AdminUsersIndexRoute,AdminVerificationsIndexRoute: AdminVerificationsIndexRoute,AdminWhatsNewIndexRoute: AdminWhatsNewIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,UsernameRoute: UsernameRouteWithChildren,R404Route: R404Route,AuthRoute: AuthRouteWithChildren,PublicRoute: PublicRouteWithChildren,UserRoute: UserRouteWithChildren,AdminRoute: AdminRouteWithChildren,CoachSplatRoute: CoachSplatRoute,SummitSpecialThankYouRoute: SummitSpecialThankYouRoute,SummitAgendaRoute: SummitAgendaRoute,SummitRegisterRoute: SummitRegisterRoute,SummitStreamRoute: SummitStreamRoute,AcceptInvitationIndexRoute: AcceptInvitationIndexRoute,IntakeIndexRoute: IntakeIndexRoute,SummitIndexRoute: SummitIndexRoute,SummitSpecialCheckoutOfferIdRoute: SummitSpecialCheckoutOfferIdRoute,SummitSummitIdAgendaRoute: SummitSummitIdAgendaRoute,SummitDayNumberRoute: SummitDayNumberRoute,ApiGhlSetUserPermissionsIndexRoute: ApiGhlSetUserPermissionsIndexRoute,EmbedAppointmentsChartIndexRoute: EmbedAppointmentsChartIndexRoute,EmbedCoachDashboardIndexRoute: EmbedCoachDashboardIndexRoute,EmbedCoachLevelsIndexRoute: EmbedCoachLevelsIndexRoute,EmbedCoachesChartIndexRoute: EmbedCoachesChartIndexRoute,EmbedDiscoveryChartIndexRoute: EmbedDiscoveryChartIndexRoute,EmbedDiscoveryEligibleCoachesIndexRoute: EmbedDiscoveryEligibleCoachesIndexRoute,EmbedEngagementsChartIndexRoute: EmbedEngagementsChartIndexRoute,EmbedIntakeChartIndexRoute: EmbedIntakeChartIndexRoute,EmbedNewCoaches30dIndexRoute: EmbedNewCoaches30dIndexRoute,EmbedNumberOfAppointmentsIndexRoute: EmbedNumberOfAppointmentsIndexRoute,EmbedNumberOfCoachesIndexRoute: EmbedNumberOfCoachesIndexRoute,EmbedNumberOfUsersIndexRoute: EmbedNumberOfUsersIndexRoute,EmbedSessionsChartIndexRoute: EmbedSessionsChartIndexRoute,EmbedUsersChartIndexRoute: EmbedUsersChartIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)